<div class="report-filter-component"
  [ngClass]="isMultiLocationEnabled && hasMultiLocationFilter && canSwitchLocation ? 'multiLocationFilterDrawer' : ''">
  <div [pTooltip]="toolTip" tooltipPosition="right" tooltipStyleClass="business-summary-tooltip"
    class="white-space report-name" [ngClass]="{
      'w-170px': ['canned-service'].includes(id),
      'w-850px': ['canned-service-detail', 'technician-detail', 'technician-summary-all-service-details'].includes(id),
      'w-250px': ['outstanding-invoice', 'google-review', 'internal-survey'].includes(id),
      'item-sold-detail-heading-wrapper': ['items-enhance-item-sold-detail'].includes(id)
    }">
    <i class="fal fa-chevron-left pointer"
      *ngIf="['canned-service-detail', 'technician-attendance-log-details', 'items-enhance-item-sold-detail'].includes(id)"
      (click)="back()"></i>
    <p class="mb-0" [ngClass]="{'text-truncate': ['items-enhance-item-sold-detail'].includes(id)}"
      [pTooltip]="['items-enhance-item-sold-detail'].includes(id) ? heading : ''" tooltipPosition="bottom"
      tooltipStyleClass="business-summary-tooltip">
      {{ heading }}
    </p>
    <i *ngIf="['canned-service', 'profitability', 'technician-activity', 'technician-summary'].includes(id)"
      class="far fa-info-circle font-gray font-14 mt-1 ml-1"></i>
    <img *ngIf="source" alt="motor" class="motor-icon" src="../../../../../assets/img/motor-icon-sm.ico" />
  </div>

  <div class="secondary-filter-wrappers">
    <div class="report-filter-date" *ngIf="options.dateRang && !hasStatement"
      [ngClass]="{ 'width-240': path === '/reports/all-payments' }">
      <div class="dashboard-date flex-start-center mr-2"
        [ngClass]="{ 'ml-1': path !== '/reports/all-payments', 'mt-8px' : path === '/reports/technician-attendance-log', 'mt-8px' : path === '/reports/technician-attendance-log-details' }">
        <i class="fal fa-chevron-left font-gray mr-1 mt-3 pointer" *ngIf="
            showDateNavigation &&
            (filterApplied.date === 'custom' ||
              ['technician-attendance-log'].includes(id) ||
              (['technician-attendance-log-details'].includes(id) && this.filterTitle.date !== 'All time' && this.filterTitle.date !== 'custom'))
          " (click)="dateBack()"></i>

        <div class="date-label-key" [ngClass]="{
            'flex-center-center': path !== '/reports/all-payments',
            'mt-2': path !== 'create-statement',
            'min-width-150': path === '/reports/technician-activity-records' || path === '/reports/technician-summary',
            'dashboard-date-inner-alignment': path === '/reports/all-payments',
            'min-width-301 mt-1': this.filterTitle.date && dateType,
            'commission-report-date': options.roType,
            'dashboard-date-inner': !options.roType
          }">
          <p class="m-0 font-600" *ngIf="dateType">
            <!-- <i class="fal fa-calendar-alt pl-1 mr-2"></i> -->
            <span class="font-11">Filter by:</span>
            <span class="font-11 font-black pl-1 font-600">{{ dateType }}</span>
            <span *ngIf="dateRangeHoverInfo"><i class="far fa-info-circle ml-1" tooltipPosition="top"
                [pTooltip]="dateRangeHoverInfo"></i></span>
          </p>
          <!-- <p class="m-0 font-600" *ngIf="!dateType"><i class="fal fa-calendar-alt pl-1 mr-2"></i>Invoice Date:</p> -->
          <div class="date-key" [ngClass]="{ 'min-width-200': dateType}">
            <!-- <span class="mr-2" *ngIf="dateType">{{ dateType }}</span> -->
            <!-- <span class="date-title mr-1" *ngIf="!options.roType">Invoice Date:</span> -->
            <span class="title font-black font-600 font-11" *ngIf="dateTitle">( {{ dateTitle }} )</span>
          </div>
        </div>

        <i class="fal fa-chevron-right mt-3 font-gray ml-1" *ngIf="
            showDateNavigation &&
            (filterApplied.date === 'custom' ||
              ['technician-attendance-log'].includes(id) ||
              (['technician-attendance-log-details'].includes(id) && this.filterTitle.date !== 'All time' && this.filterTitle.date !== 'custom'))
          " (click)="dateNext()"></i>
      </div>
    </div>
  </div>
  <div class="left-side-filters" [ngClass]="{'flex-center-center': notShowMobileView}">
    <div id="statement-start-date-filter" class="filter-pill date-filter" *ngIf="options.date && !hasStatement"
      [ngClass]="{ invisible: isDisableDateFilter, 'mr-4': !notShowMobileView, 'm-0 mr-0 mt-0 commission-date-filter': notShowMobileView }">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-17%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{'font-primary': notShowMobileView}">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text text-overflow-ellipsis font-600 font-10"
              [ngClass]="{ 'w-80px': !options.roType, 'w-70px-imp': notShowMobileView }">
              {{ options.roType ? 'ROs paid (' + filterTitle.date + ')' : filterTitle.date }}
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down"
                [ngClass]="{'font-primary': notShowMobileView, 'font-bold': !notShowMobileView}"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-170">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of dateFilterOption"
              (click)="onDateSelect(filterOption.id)"
              [ngClass]="{ 'active-date': filterApplied.date === filterOption.id }">
              {{ filterOption.title }}
              <span [ngClass]="{ 'active-date': filterApplied.date === filterOption.id }"
                *ngIf="filterOption.id === 'this-week' || filterOption.id === 'last-week'" class="week-days-label">(Mon
                - Sun)</span>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
      <span class="date-divider" *ngIf="!notShowMobileView"></span>
    </div>
    <!-- Single day -->
    <div id="customer-aging-filter" class="filter-pill date-filter mr-4" *ngIf="options.singleDay">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-17%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text text-overflow-ellipsis font-600" [ngClass]="{ 'w-80px': !options.roType }">
              {{ options.roType ? 'ROs paid (' + filterTitle.date + ')' : filterTitle.date }}
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down font-bold"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-170">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of singleDayFilterOption"
              (click)="onDateSelect(filterOption.id)" [ngClass]="{ active: filterApplied.date === filterOption.id }">
              {{ filterOption.title }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
      <span class="date-divider" *ngIf="!notShowMobileView"></span>
    </div>
    <!-- End Single day -->

    <!-- single month -->
    <div id="customer-aging-filter" class="filter-pill date-filter mr-4" *ngIf="options.singleMonth">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-17%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text text-overflow-ellipsis font-600" [ngClass]="{ 'w-80px': !options.roType }">
              {{ filterTitle.date }}
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down font-bold"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-170">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of singleMonthFilterOption"
              (click)="onDateSelect(filterOption.id)" [ngClass]="{ active: filterApplied.date === filterOption.id }">
              {{ filterOption.title }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
      <span class="date-divider" *ngIf="!notShowMobileView"></span>
    </div>
    <!-- single month end -->
  </div>

  <div class="report-filter-inner filter-desktop">

    <!-- Export Button -->
    <div class="report-export export-btn exp-btn" *ngIf="hasExport">
      <button class="btn btn-primary btn-submit" (click)="onExport()"><i
          class="fal fa-file-upload mr-1"></i><span>Export</span></button>
    </div>
    <!-- Export Button End-->

    <!-- export dorpdown for midas only -->
    <div class="report-export export-btn exp-btn" *ngIf="hasExportMidas">
      <!-- Dropdown Button -->
      <div class="dropdown">
        <button class="btn btn-primary btn-submit dropdown-toggle" type="button" id="exportDropdown"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fal fa-file-upload mr-1"></i><span>Export</span>
        </button>

        <!-- Dropdown Menu -->
        <div class="dropdown-menu" aria-labelledby="exportDropdown">
          <!-- First Export Option -->
          <button class="dropdown-item" (click)="onExport()">
            <i class="fal fa-file-alt mr-1"></i> Export CSV
          </button>
          <!-- Second Export Option -->
          <button class="dropdown-item" (click)="onExportXML()">
            <i class="fal fa-code mr-1"></i> Export XML
          </button>
        </div>
      </div>
    </div>
    <!-- export dropdowm for midas only end  -->

    <!-- Print Button -->
    <div class="report-export" *ngIf="hasPrint">
      <button class="btn btn-submit flex-center-center print-btn">
        <span (click)="onExport(true)"><i class="fal fa-print"></i>Print</span>
        <span (click)="$event.stopPropagation(); viewPrintLogs()">
          <i class="fal fa-history"></i>
        </span>
      </button>
    </div>

    <div class="report-export export-btn exp-btn" *ngIf="hasSchedule && id !== 'royalty'">

      <button class="btn btn-primary btn-submit" (click)="onExport(true)"><i
          class="fal fa-print mr-2"></i><span>Print</span></button>
    </div>

    <!-- Schedule Button -->
    <div class="report-export" *ngIf="hasSchedule">
      <button class="btn btn-submit flex-center-center print-btn" [disabled]="isDisableScheduleBtn && id !== 'royalty'"
        (click)="onSchedule()">
        <span><i class="fal fa-calendar-alt"></i>&nbsp;&nbsp; Schedule</span>
      </button>
    </div>

    <!-- Start Workflow -->
    <div class="filter-pill workflow" *ngIf="options.workflow">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-12%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.workflow }">
            <div class="icon">
              <i class="fal fa-stream"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span>{{ filterTitle?.workflow }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.workflow"></i>
              <i class="fal fa-times" *ngIf="filterApplied.workflow" (click)="clearFilter('workflow')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter scrollHeight="260px" valueField="id" [data]="workFlowStatuses"
              [selectedValue]="filter.workflow" (appChangeFilter)="onSelectWorkflow($event)"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Workflow -->

    <!-- Start Item Tax type -->
    <div class="filter-pill company-name" *ngIf="options.taxItemType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.taxItemType }">
            <div class="icon">
              <i class="fal fa-box"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.taxItemType?.selected?.length === 0">{{ filterTitle?.taxItemType?.all }}</span>
              <span *ngIf="filter?.taxItemType?.selected?.length === 1">{{ (filter?.taxItemType?.selected)[0]?.name
                }}</span>
              <span *ngIf="filter?.taxItemType?.selected?.length > 1">{{ filterTitle?.taxItemType?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.taxItemType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.taxItemType" (click)="clearFilter('taxItemType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="taxItemTypes"
              (appChangeFilter)="onSelectItemTaxTypeName($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End  Item Tax type -->

    <!-- Multi Tax Code filter -->
    <div class="single-filter" *ngIf="options.multiTaxCode">
      <!-- Start Tax Code -->
      <div class="filter-pill location">
        <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
          [closeAfterAction]="closeAfterAction" right="-13%">
          <ng-template appTemplate="item">
            <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.multiTaxCode }">
              <div class="icon">
                <i class="fal fa-stream"></i>
              </div>

              <div class="filter-text w-90px text-overflow-ellipsis">
                <span *ngIf="filter?.multiTaxCode?.selected?.length === 0">{{ filterTitle?.multiTaxCode?.all }}</span>
                <span *ngIf="filter?.multiTaxCode?.selected?.length === 1">{{ (filter?.multiTaxCode?.selected)[0]?.name
                  }}</span>
                <span *ngIf="filter?.multiTaxCode?.selected?.length > 1">{{ filterTitle?.multiTaxCode?.multiple
                  }}</span>
              </div>

              <div class="filter-cross">
                <i class="fal fa-chevron-down" *ngIf="!filterApplied.multiTaxCode"></i>
                <i class="fal fa-times" *ngIf="filterApplied.multiTaxCode" (click)="clearFilter('multiTaxCode')"></i>
              </div>
            </div>
          </ng-template>

          <ng-template appTemplate="overlay">
            <div class="filter-overlay w-180 text-overflow-ellipsis">
              <app-multiple-filter scrollHeight="265px" [data]="taxCodeList"
                (appChangeFilter)="changeTaxcodeFilter($event)"> </app-multiple-filter>
            </div>
          </ng-template>
        </app-content-overlay>
      </div>
      <!-- End Tax Code -->
    </div>

    <!-- Start Tax code -->
    <div class="filter-pill taxCode" *ngIf="options.taxCode">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-12%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.taxCode }">
            <div class="icon">
              <i class="fal fa-stream"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span *ngIf="!filter?.taxCode?._id">Tax code</span>
              <span *ngIf="filter?.taxCode?._id">{{ filter?.taxCode?.name }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.taxCode"></i>
              <i class="fal fa-times" *ngIf="filterApplied.taxCode" (click)="clearFilter('taxCode')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter scrollHeight="260px" valueField="_id" [data]="taxCodes" [selectedValue]="filter.taxCode"
              (appChangeFilter)="onTaxCodeSelect($event)"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tax code -->

    <!-- Start Order Status -->
    <div class="filter-pill order-status" *ngIf="options.orderStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-9%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderStatus }">
            <div class="icon">
              <i class="fal fa-tasks"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.orderStatus?.estimate && filter?.orderStatus?.invoice">
                {{ filterTitle?.orderStatus?.all }}
              </span>

              <span *ngIf="filter?.orderStatus?.estimate && !filter?.orderStatus?.invoice">
                {{ filterTitle?.orderStatus?.estimate }}
              </span>

              <span *ngIf="!filter?.orderStatus?.estimate && filter?.orderStatus?.invoice">
                {{ filterTitle?.orderStatus?.invoice }}
              </span>

              <span *ngIf="!filter?.orderStatus?.estimate && !filter?.orderStatus?.invoice">
                {{ filterTitle?.orderStatus?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.orderStatus" (click)="clearFilter('orderStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('orderStatus', 'estimate')">
              <app-checkbox [isChecked]="filter.orderStatus.estimate"> </app-checkbox>
              {{ filterTitle.orderStatus.estimate }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('orderStatus', 'invoice')">
              <app-checkbox [isChecked]="filter.orderStatus.invoice"> </app-checkbox>
              {{ filterTitle.orderStatus.invoice }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Order Status -->

    <!-- Start RO Status -->
    <div class="filter-pill ro-status for-tech-worked-summary" *ngIf="options.roStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-9%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.roStatus }">
            <div class="icon">
              <i class="fal fa-tasks"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <!-- Show "All" when all filters are selected -->
              <span *ngIf="filter?.roStatus?.estimate && filter?.roStatus?.invoice && filter?.roStatus?.finalized">
                {{ filterTitle?.roStatus?.all }}
              </span>

              <!-- Show individual filter names if only one is selected -->
              <span *ngIf="filter?.roStatus?.estimate && !filter?.roStatus?.invoice && !filter?.roStatus?.finalized">
                {{ filterTitle?.roStatus?.estimate }}
              </span>

              <span *ngIf="filter?.roStatus?.invoice && !filter?.roStatus?.estimate && !filter?.roStatus?.finalized">
                {{ filterTitle?.roStatus?.invoice }}
              </span>

              <span *ngIf="filter?.roStatus?.finalized && !filter?.roStatus?.estimate && !filter?.roStatus?.invoice">
                {{ filterTitle?.roStatus?.finalized }}
              </span>

              <!-- Show "Multiple Status" -->
              <span *ngIf="(filter?.roStatus?.estimate && filter?.roStatus?.invoice && !filter?.roStatus?.finalized) ||
                       (filter?.roStatus?.estimate && filter?.roStatus?.finalized && !filter?.roStatus?.invoice) ||
                       (filter?.roStatus?.invoice && filter?.roStatus?.finalized && !filter?.roStatus?.estimate)">
                {{ filterTitle?.roStatus?.multiple }}
              </span>

              <!-- Show "All" if no filters are selected -->
              <span *ngIf="!filter?.roStatus?.estimate && !filter?.roStatus?.invoice && !filter?.roStatus?.finalized">
                {{ filterTitle?.roStatus?.all }}
              </span>
            </div>



            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.roStatus"></i>
              <i class="fal fa-times hide-for-tech-sumary" *ngIf="filterApplied.roStatus"
                (click)="clearFilter('roStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('roStatus', 'estimate')">
              <app-checkbox [isChecked]="filter.roStatus.estimate"> </app-checkbox>
              {{ filterTitle.roStatus.estimate }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('roStatus', 'invoice')">
              <app-checkbox [isChecked]="filter.roStatus.invoice"> </app-checkbox>
              {{ filterTitle.roStatus.invoice }}
            </div>
            <div *ngIf="isRevenueRecognitionSettleEnabled" class="filter-option border-bottom-lightest"
              (click)="onChange('roStatus', 'finalized')">
              <app-checkbox [isChecked]="filter.roStatus.finalized"> </app-checkbox>
              {{ filterTitle.roStatus.finalized }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Order Status -->

    <!-- Start Order Status for tech summary by all service -->
    <div class="filter-pill order-status" *ngIf="options.orderStatusTechSummary">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-8%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderStatusTechSummary }">
            <div class="icon">
              <i class="fal fa-tasks"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ orderStatusAllServiceNameDisplay() }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderStatusTechSummary"></i>
              <i class="fal fa-times" *ngIf="filterApplied.orderStatusTechSummary"
                (click)="clearFilter('orderStatusTechSummary')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter valueField="id" scrollHeight="198px" [data]="orderStatusForAllServices"
              [selectedValue]="filter.orderStatusTechSummary" (appChangeFilter)="onSelectOrderStatusAllService($event)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Order Status for tech summary by all service -->

    <!-- Start Ordering status -->
    <div class="filter-pill payment-type-1" *ngIf="options.orderingStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderingStatus }">
            <div class="icon">
              <i class="fal fa-clipboard-check"></i>
            </div>

            <div class="filter-text w-120px text-overflow-ellipsis mr-1">
              <span>{{ showOrderingStatusTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderingStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.orderingStatus" (click)="clearFilter('orderingStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="filter-overlay w-160">
            <div class="filter-option" (click)="onChange('orderingStatus', 'unordered')">
              <app-checkbox [isChecked]="filter.orderingStatus.unordered"> </app-checkbox>
              {{ filterTitle.orderingStatus.unordered }}
            </div>

            <div class="filter-option" (click)="onChange('orderingStatus', 'ordered')">
              <app-checkbox [isChecked]="filter.orderingStatus.ordered"> </app-checkbox>
              {{ filterTitle.orderingStatus.ordered }}
            </div>
            <div class="filter-option" (click)="onChange('orderingStatus', 'delivered')">
              <app-checkbox [isChecked]="filter.orderingStatus.delivered"> </app-checkbox>
              {{ filterTitle.orderingStatus.delivered }}
            </div>
            <div class="filter-option" (click)="onChange('orderingStatus', 'cancelled')">
              <app-checkbox [isChecked]="filter.orderingStatus.cancelled"> </app-checkbox>
              {{ filterTitle.orderingStatus.cancelled }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Ordering status -->

    <!-- Start payment Term -->
    <div class="filter-pill payment-type-1" *ngIf="options.paymentTerms">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentTerms }">
            <div class="icon">
              <i class="fal fa-file-invoice"></i>
            </div>

            <div class="filter-text w-120px text-overflow-ellipsis mr-1">
              <span>{{ showPaymenTermsTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentTerms"></i>
              <i class="fal fa-times" *ngIf="filterApplied.paymentTerms" (click)="clearFilter('paymentTerms')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="filter-overlay w-160">
            <div class="filter-option" (click)="onChange('paymentTerms', 'payable')">
              <app-checkbox [isChecked]="filter.paymentTerms.payable"> </app-checkbox>
              {{ filterTitle.paymentTerms.payable }}
            </div>

            <div class="filter-option" (click)="onChange('paymentTerms', 'cod')">
              <app-checkbox [isChecked]="filter.paymentTerms.cod"> </app-checkbox>
              {{ filterTitle.paymentTerms.cod }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End payment term -->

    <!-- Start Ordering methods -->
    <div class="filter-pill payment-type-1" *ngIf="options.orderingMethods">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderingMethods }">
            <div class="icon">
              <i class="fal fa-file-alt"></i>
            </div>

            <div class="filter-text w-120px text-overflow-ellipsis mr-1">
              <span>{{ showOrderingMethodsTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderingMethods"></i>
              <i class="fal fa-times" *ngIf="filterApplied.orderingMethods"
                (click)="clearFilter('orderingMethods')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="filter-overlay w-160">
            <div class="filter-option" (click)="onChange('orderingMethods', 'online')">
              <app-checkbox [isChecked]="filter.orderingMethods.online"> </app-checkbox>
              {{ filterTitle.orderingMethods.online }}
            </div>

            <div class="filter-option" (click)="onChange('orderingMethods', 'offline')">
              <app-checkbox [isChecked]="filter.orderingMethods.offline"> </app-checkbox>
              {{ filterTitle.orderingMethods.offline }}
            </div>
            <div class="filter-option" (click)="onChange('orderingMethods', 'inventory')">
              <app-checkbox [isChecked]="filter.orderingMethods.inventory"> </app-checkbox>
              {{ filterTitle.orderingMethods.inventory }}
            </div>
            <div class="filter-option" (click)="onChange('orderingMethods', 'provisional')">
              <app-checkbox [isChecked]="filter.orderingMethods.provisional"> </app-checkbox>
              {{ filterTitle.orderingMethods.provisional }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Ordering methods -->

    <!-- Start Archives -->
    <div class="filter-pill archives" *ngIf="options.archives">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-8%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.archives }">
            <div class="icon">
              <i class="fal fa-archive"></i>
            </div>

            <div class="filter-text w-70px text-overflow-ellipsis">
              <span *ngIf="filter?.archives?.archived && filter?.archives?.unArchived">
                {{ filterTitle?.archives?.all }}
              </span>

              <span *ngIf="filter?.archives?.archived && !filter?.archives?.unArchived">
                {{ filterTitle?.archives?.archived }}
              </span>

              <span *ngIf="!filter?.archives?.archived && filter?.archives?.unArchived">
                {{ filterTitle?.archives?.unArchived }}
              </span>

              <span *ngIf="filter?.archives?.archived === false && filter?.archives?.unArchived === false">
                {{ filterTitle?.archives?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.archives"></i>
              <i class="fal fa-times" *ngIf="filterApplied.archives" (click)="clearFilter('archives')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('archives', 'archived')">
              <app-checkbox [isChecked]="filter.archives.archived"> </app-checkbox>
              {{ filterTitle.archives.archived }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('archives', 'unArchived')">
              <app-checkbox [isChecked]="filter.archives.unArchived"> </app-checkbox>
              {{ filterTitle.archives.unArchived }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Archives -->

    <!-- Start Payment Status -->
    <div class="filter-pill payment-status" *ngIf="options.paymentStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-18%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentStatus }">
            <div class="icon">
              <i class="fal fa-user-hard-hat"></i>
            </div>

            <div class="filter-text w-70px text-overflow-ellipsis">
              {{ filterTitle?.paymentStatus }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.paymentStatus" (click)="clearFilter('paymentStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter [data]="paymentStatusOptions" valueField="id" [selectedValue]="filter.paymentStatus"
              scrollHeight="260px" (appChangeFilter)="onSelectPaymentStatus($event)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Payment Status -->

    <!-- Start credit memo -->
    <div class="filter-pill payment-status" *ngIf="options.creditMemo">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-18%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.creditMemo }">
            <div class="icon">
              <i class="fal fa-user-hard-hat"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ filterTitle?.creditMemo }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.creditMemo"></i>
              <i class="fal fa-times" *ngIf="filterApplied.creditMemo" (click)="clearFilter('creditMemo')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter [data]="creditMemoOptions" valueField="id" [selectedValue]="filter.creditMemo"
              scrollHeight="260px" (appChangeFilter)="onSelectCreditStatus($event)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Payment Status -->

    <!-- Start Item Payment Status -->
    <div class="filter-pill payment-status" *ngIf="options.itemPaymentStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-18%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.itemPaymentStatus }">
            <div class="icon">
              <i class="fal fa-user-hard-hat"></i>
            </div>

            <div class="filter-text w-70px text-overflow-ellipsis">
              {{ filterTitle?.itemPaymentStatus }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemPaymentStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.itemPaymentStatus"
                (click)="clearFilter('itemPaymentStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter [data]="itemPaymentStatusOptions" valueField="id"
              [selectedValue]="filter.itemPaymentStatus" scrollHeight="260px"
              (appChangeFilter)="onSelectItemPaymentStatus($event)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Payment Status -->

    <!-- Start Statemnet -->
    <div class="filter-pill rating" *ngIf="options.statementStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-1%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.statementStatus }">
            <div class="icon">
              <i class="fal fa-receipt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ filterTitle.statementTitle }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.statementStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.statementStatus"
                (click)="clearFilter('statementStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <app-single-filter scrollHeight="260px" valueField="id" [data]="statmentOptions"
              [selectedValue]="this.filter.statementStatus" (appChangeFilter)="onSelectStatemnet($event)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Statemnet -->

    <!-- Start Canned Service Category -->
    <div class="filter-pill canned-service" *ngIf="options.category">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.category }">
            <div class="icon">
              <i class="fal fa-th"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              {{ filterTitle.category }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.category"></i>
              <i class="fal fa-times" *ngIf="filterApplied.category" (click)="clearFilter('category')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter scrollHeight="260px" valueField="id" [data]="categories"
              [selectedValue]="this.filter.category" (appChangeFilter)="onSelectCategory($event)"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Canned Service Category -->

    <!-- Start Activity Type -->
    <div class="filter-pill activity-type" *ngIf="options.activity">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.activity }">
            <div class="icon">
              <i class="fal fa-stopwatch"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span *ngIf="filter?.activity?.inspections && filter?.activity?.services">
                {{ filterTitle?.activity?.all }}
              </span>

              <span *ngIf="filter?.activity?.inspections && !filter?.activity?.services">
                {{ filterTitle?.activity?.inspections }}
              </span>

              <span *ngIf="!filter?.activity?.inspections && filter?.activity?.services">
                {{ filterTitle?.activity?.services }}
              </span>

              <span *ngIf="!filter?.activity?.inspections && !filter?.activity?.services">
                {{ filterTitle?.activity?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.activity"></i>
              <i class="fal fa-times" *ngIf="filterApplied.activity" (click)="clearFilter('activity')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('activity', 'inspections')">
              <app-checkbox [isChecked]="filter.activity.inspections"> </app-checkbox>
              {{ filterTitle.activity.inspections }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('activity', 'services')">
              <app-checkbox [isChecked]="filter.activity.services"> </app-checkbox>
              {{ filterTitle.activity.services }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Activity Type -->

    <!-- Start Ratings -->
    <div class="filter-pill rating" *ngIf="options.ratings">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-1%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.rating }">
            <div class="icon">
              <i class="fal fa-star"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ filterTitle.rating }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.rating"></i>
              <i class="fal fa-times" *ngIf="filterApplied.rating" (click)="clearFilter('rating')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <app-single-filter scrollHeight="260px" valueField="id" [data]="ratingOptions"
              [selectedValue]="this.filter.rating" (appChangeFilter)="onSelectRating($event)"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Ratings -->

    <!-- Add Filter -->
    <div class="add-filter add-filter-button" *ngIf="options.addFilter">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" right="-10%" [closeAfterAction]="closeAfterAction"
        arrowRight="25%">
        <ng-template appTemplate="item">
          <span class="font-primary font-700 font-12 mt-5px text-nowrap"><i class="fal fa-plus"></i> Add filter</span>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="filter-overlay w-160">
            <div class="filter-heading border-bottom-lightest">Customer Type</div>

            <div class="filter-option" (click)="onChange('customerType', 'newCustomers')">
              <app-checkbox [isChecked]="filter.customerType.newCustomers"> </app-checkbox>
              {{ filterTitle.customerType.newCustomers }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('customerType', 'repeatCustomers')">
              <app-checkbox [isChecked]="filter.customerType.repeatCustomers"> </app-checkbox>
              {{ filterTitle.customerType.repeatCustomers }}
            </div>

            <div class="filter-heading border-bottom-lightest">Payment</div>

            <div class="filter-option" (click)="onChange('payment', 'unpaid')">
              <app-checkbox [isChecked]="filter.payment.unpaid"> </app-checkbox>
              {{ filterTitle.payment.unpaid }}
            </div>

            <div class="filter-option" (click)="onChange('payment', 'partiallyPaid')">
              <app-checkbox [isChecked]="filter.payment.partiallyPaid"> </app-checkbox>
              {{ filterTitle.payment.partiallyPaid }}
            </div>

            <div class="filter-option" (click)="onChange('payment', 'paid')">
              <app-checkbox [isChecked]="filter.payment.paid"> </app-checkbox>
              {{ filterTitle.payment.paid }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <!-- ----Multilocation Filter-------- -->
    <div *ngIf="isMultiLocationEnabled && hasMultiLocationFilter && canSwitchLocation" class="mr-3">
      <app-shop-location-dropdown [(preSelectedLocationsIds)]="preSelectedLocationsIds" class="ml-2 d-inline-block mt-3"
        type="item-return" (filterChange)="onMultiLocationChange($event)"> </app-shop-location-dropdown>
    </div>
    <!-- ------------ -->
    <!-- start sales code -->
    <div class="filter-pill technician salesCode" *ngIf="options.salesCode">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-8%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.salesCode }">
            <div class="icon">
              <i class="fal fa-user-hard-hat"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ salesCodeDisplay() }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.salesCode"></i>
              <i class="fal fa-times" *ngIf="filterApplied.salesCode" (click)="clearFilter('salesCode')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter valueField="_id" scrollHeight="198px" nameField="title" [data]="salesCodeResults"
              [selectedValue]="filter.salesCode" (appChangeFilter)="onSelectSalesCode($event)" (scroll)="onScrollGetSalesCode()"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- end sales code -->

    <!-- Start Sales Group -->
    <div class="filter-pill technician salesGroup" *ngIf="options.salesGroup">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-8%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.salesGroup }">
            <div class="icon">
              <i class="fal fa-user-hard-hat"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ salesGroupDisplay() }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.salesGroup"></i>
              <i class="fal fa-times" *ngIf="filterApplied.salesGroup" (click)="clearFilter('salesGroup')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter valueField="_id" scrollHeight="198px" [data]="salesGroupsResults"
              [selectedValue]="filter.salesGroup" (appChangeFilter)="onSelectSalesGroup($event)"
              (scroll)="onScrollGetSalesGroup()"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Sales group -->

    <!-- Start Technicians -->
    <div class="filter-pill technician" *ngIf="options.tech">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-8%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tech }">
            <div class="icon">
              <i class="fal fa-user-hard-hat"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ techNameDisplay() }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.tech"></i>
              <i class="fal fa-times" *ngIf="filterApplied.tech" (click)="clearFilter('tech')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter valueField="id" scrollHeight="198px" [data]="technicians" [selectedValue]="filter.tech"
              (appChangeFilter)="onSelectTechnician($event)"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Technicians -->

    <!-- Start Service Advisor -->
    <div class="filter-pill advisor" *ngIf="options.serviceWriter">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-8%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.serviceWriter }">
            <div class="icon">
              <i class="fal fa-user-hard-hat"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ serviceWriterDisplay() }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.serviceWriter"></i>
              <i class="fal fa-times" *ngIf="filterApplied.serviceWriter" (click)="clearFilter('serviceWriter')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-single-filter valueField="id" scrollHeight="260px" [data]="serviceWriterUsers"
              [selectedValue]="filter.serviceWriter" (appChangeFilter)="onSelectServiceWriter($event)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Service Advisor -->

    <!-- Start Last sold -->
    <div class="filter-pill last-sold" *ngIf="options.lastSold">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-30%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.lastSold }">
            <div class="icon">
              <i class="fal fa-calendar-week"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              {{ filterTitle.lastSold }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.lastSold"></i>
              <i class="fal fa-times" *ngIf="filterApplied.lastSold" (click)="clearFilter('lastSold')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-220">
            <app-single-filter scrollHeight="198px" valueField="id" [selectedValue]="this.filter.lastSold"
              [data]="lastSoldOptions" (appChangeFilter)="onSelectLastSold($event)"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Last sold -->

    <!-- Start Customer Type -->
    <div class="filter-pill customer-type" *ngIf="options.customerType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.customerType }">
            <div class="icon">
              <i class="fal fa-user"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span *ngIf="filter?.customerType?.newCustomers && filter?.customerType?.repeatCustomers">
                {{ filterTitle?.customerType?.all }}
              </span>

              <span *ngIf="filter?.customerType?.newCustomers && !filter?.customerType?.repeatCustomers">
                {{ filterTitle?.customerType?.newCustomers }}
              </span>

              <span *ngIf="!filter?.customerType?.newCustomers && filter?.customerType?.repeatCustomers">
                {{ filterTitle?.customerType?.repeatCustomers }}
              </span>

              <span *ngIf="!filter?.customerType?.newCustomers && !filter?.customerType?.repeatCustomers">
                {{ filterTitle?.customerType?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.customerType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.customerType" (click)="clearFilter('customerType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('customerType', 'newCustomers')">
              <app-checkbox [isChecked]="filter.customerType.newCustomers"> </app-checkbox>
              {{ filterTitle.customerType.newCustomers }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('customerType', 'repeatCustomers')">
              <app-checkbox [isChecked]="filter.customerType.repeatCustomers"> </app-checkbox>
              {{ filterTitle.customerType.repeatCustomers }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Customer Type -->

    <!-- Start Type -->
    <div class="filter-pill type" *ngIf="options.customerFleet">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.customerFleet }">
            <div class="icon">
              <i class="fal fa-user"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span
                *ngIf="(filter?.customerFleet?.fleet && filter?.customerFleet?.regular) || (!filter?.customerFleet?.fleet && !filter?.customerFleet?.regular)">
                {{ filterTitle?.customerFleet?.all }}
              </span>

              <span *ngIf="filter?.customerFleet?.fleet && !filter?.customerFleet?.regular">
                {{ filterTitle?.customerFleet?.fleet }}
              </span>

              <span *ngIf="!filter?.customerFleet?.fleet && filter?.customerFleet?.regular">
                {{ filterTitle?.customerFleet?.regular }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.customerFleet"></i>
              <i class="fal fa-times" *ngIf="filterApplied.customerFleet" (click)="clearFilter('customerFleet')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('customerFleet', 'regular')">
              <app-checkbox [isChecked]="filter.customerFleet.regular"> </app-checkbox>
              {{ filterTitle.customerFleet?.regular }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('customerFleet', 'fleet')">
              <app-checkbox [isChecked]="filter.customerFleet.fleet"> </app-checkbox>
              {{ filterTitle.customerFleet?.fleet }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Type -->

    <!-- Start Tags -->
    <div class="filter-pill tags" *ngIf="options.tags" [ngClass]="{ 'width-100px': path === '/reports/all-payments' }">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tags }">
            <div class="icon">
              <i class="fal fa-tags"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.tags?.selected?.length === 0">{{ filterTitle?.tags?.all }}</span>
              <span *ngIf="filter?.tags?.selected?.length === 1">{{ (filter?.tags?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.tags?.selected?.length > 1">{{ filterTitle?.tags?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.tags"></i>
              <i class="fal fa-times" *ngIf="filterApplied.tags" (click)="clearFilter('tags')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="tags" (appChangeFilter)="changeTagFilter($event)">
            </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tags -->

    <!-- Start Payable status -->
    <div class="filter-pill" *ngIf="options.payableStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.payableStatus }">
            <div class="icon">
              <i class="fal fa-credit-card"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.payableStatus?.selected?.length === 0">Payable Status</span>
              <span *ngIf="filter?.payableStatus?.selected?.length === 1">{{ (filter?.payableStatus?.selected)[0]?.name
                }}</span>
              <span *ngIf="filter?.payableStatus?.selected?.length > 1">{{ filterTitle?.payableStatus?.multiple
                }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.payableStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.payableStatus" (click)="clearFilter('payableStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="payableStatusList"
              (appChangeFilter)="changePayableStatus($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End payable -->

    <!-- itemTypes inventory- non-inventory -->
    <div class="filter-pill technicians-filter" *ngIf="options.itemTypeInventoryNonInventory">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="0%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ 'active': filterApplied.itemTypeInventoryNonInventory }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-warehouse-alt"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filter?.itemTypeInventoryNonInventory?.selected?.length === 0">Item type</span>
              <span
                *ngIf="filter?.itemTypeInventoryNonInventory?.selected?.length === 1">{{filter?.itemTypeInventoryNonInventory?.selected[0]?.label}}</span>
              <span *ngIf="filter?.itemTypeInventoryNonInventory?.selected?.length > 1">Multiple</span>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemTypeInventoryNonInventory"></i>
              <i class="fal fa-times" *ngIf="filterApplied.itemTypeInventoryNonInventory"
                (click)="clearFilter('itemTypeInventoryNonInventory')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <app-multiple-filter scrollHeight="260px" nameField="label" [data]="itemTypeInventoryNonInventory"
              (appChangeFilter)="changeItemTypeInventoryNonInventory($event)">
            </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End itemTypes inventory- non-inventory -->

    <!-- Start order status -->
    <div class="filter-pill" *ngIf="options.orderType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderType }">
            <div class="icon">
              <i class="fal fa-credit-card"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.orderType?.selected?.length === 0">Order Type</span>
              <span *ngIf="filter?.orderType?.selected?.length === 1">{{ (filter?.orderType?.selected)[0]?.name
                }}</span>
              <span *ngIf="filter?.orderType?.selected?.length > 1">Multiple</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.orderType" (click)="clearFilter('orderType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="orderTypeList"
              (appChangeFilter)="changeOrderType($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <!-- Start Activity Type -->
    <div class="filter-pill" *ngIf="options.activityType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.activityType }">
            <div class="icon">
              <i class="fal fa-briefcase"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.activityType?.selected?.length === 0">Activity Type</span>
              <span *ngIf="filter?.activityType?.selected?.length === 1">{{ (filter?.activityType?.selected)[0]?.name
                }}</span>
              <span *ngIf="filter?.activityType?.selected?.length > 1">Multiple</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.activityType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.activityType" (click)="clearFilter('activityType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="activityTypeList"
              (appChangeFilter)="changeActivityType($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Activity Type -->

    <!-- Start Company name -->
    <div class="filter-pill company-name" *ngIf="options.companyName">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.companyName }">
            <div class="icon">
              <i class="fal fa-tags"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.companyName?.selected?.length === 0">{{ filterTitle?.companyName?.all }}</span>
              <span *ngIf="filter?.companyName?.selected?.length === 1">{{ (filter?.companyName?.selected)[0]?.name
                }}</span>
              <span *ngIf="filter?.companyName?.selected?.length > 1">{{ filterTitle?.companyName?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.companyName"></i>
              <i class="fal fa-times" *ngIf="filterApplied.companyName" (click)="clearFilter('companyName')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="companyNames"
              (appChangeFilter)="onSelectCompanyName($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End company name -->

    <!-- Start Agging -->
    <div class="filter-pill agging" *ngIf="options.aging">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="0%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.aging }">
            <div class="icon">
              <i class="fal fa-bell-exclamation"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              {{ filterTitle?.aging }}
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.aging"></i>
              <i class="fal fa-times" *ngIf="filterApplied.aging" (click)="clearFilter('aging')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-120">
            <app-single-filter scrollHeight="260px" valueField="id" [selectedValue]="this.filter.aging"
              [data]="agingOptions" (appChangeFilter)="onSelectAging($event)"> </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Agging -->

    <!-- Start Payment -->
    <div class="filter-pill payment" *ngIf="options.payment">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.payment }">
            <div class="icon">
              <i class="fal fa-credit-card"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span>{{ showPaymentPill() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.payment"></i>
              <i class="fal fa-times" *ngIf="filterApplied.payment" (click)="clearFilter('payment')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option" (click)="onChange('payment', 'unpaid')">
              <app-checkbox [isChecked]="filter.payment.unpaid"> </app-checkbox>
              {{ filterTitle.payment.unpaid }}
            </div>

            <div class="filter-option" (click)="onChange('payment', 'partiallyPaid')">
              <app-checkbox [isChecked]="filter.payment.partiallyPaid"> </app-checkbox>
              {{ filterTitle.payment.partiallyPaid }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Payment -->

    <!-- Start QBO Status -->
    <div class="filter-pill qbo-status" *ngIf="options.qboStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.qboStatus }">
            <div class="icon">
              <i class="fal fa-coins"></i>
            </div>

            <div class="filter-text w-120px text-overflow-ellipsis mr-1">
              <span>{{ showqboStatusTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.qboStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.qboStatus" (click)="clearFilter('qboStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option" (click)="onChange('qboStatus', 'synced')">
              <app-checkbox [isChecked]="filter.qboStatus.synced"> </app-checkbox>
              {{ filterTitle.qboStatus.synced }}
            </div>

            <div class="filter-option" (click)="onChange('qboStatus', 'notSynced')">
              <app-checkbox [isChecked]="filter.qboStatus.notSynced"> </app-checkbox>
              {{ filterTitle.qboStatus.notSynced }}
            </div>

            <div class="filter-option" (click)="onChange('qboStatus', 'notPosted')">
              <app-checkbox [isChecked]="filter.qboStatus.notPosted"> </app-checkbox>
              {{ filterTitle.qboStatus.notPosted }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End QBO Status -->

    <!-- Start Payment Type -->
    <div class="filter-pill payment-sub-type" *ngIf="options.paymentSubType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentSubType }">
            <div class="icon">
              <i class="fal fa-stream"></i>
            </div>

            <div class="filter-text w-120px text-overflow-ellipsis mr-1">
              <span>Payment method</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentSubType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.paymentSubType" (click)="clearFilter('paymentSubType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="filter-overlay w-160">
            <div *ngIf="!filterApplied.paymentType" class="filter-option">Select Payment Type</div>
            <div *ngFor="let filterOption of filter.paymentSubTypeFilterOption"
              (click)="onSubTypeSelect(filterOption._id)">
              <div *ngIf="filter.paymentSubTypeFilterOption.length > 0" class="filter-option">
                <app-checkbox [isChecked]="filterOption.selected"> </app-checkbox>
                {{ filterOption.name }}
              </div>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Payment Type -->

    <!-- Start Payment Type -->
    <div class="filter-pill payment-type-1" *ngIf="options.paymentType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentType }">
            <div class="icon">
              <i class="fal fa-file-invoice"></i>
            </div>

            <div class="filter-text w-120px text-overflow-ellipsis mr-1">
              <span>{{ showPaymentTypeTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.paymentType" (click)="clearFilter('paymentType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="filter-overlay w-160">
            <div class="filter-option" (click)="onChange('paymentType', 'cash')">
              <app-checkbox [isChecked]="filter.paymentType.cash"> </app-checkbox>
              {{ filterTitle.paymentType.cash }}
            </div>

            <div *ngIf="!isOnlinePayAvailable" class="filter-option" (click)="onChange('paymentType', 'card')">
              <app-checkbox [isChecked]="filter.paymentType.card"> </app-checkbox>
              {{ filterTitle.paymentType.card }}
            </div>
            <div *ngIf="isOnlinePayAvailable" class="filter-option" (click)="onChange('paymentType', 'cardManual')">
              <app-checkbox [isChecked]="filter.paymentType.cardManual"> </app-checkbox>
              {{ filterTitle.paymentType.cardManual }}
            </div>
            <div *ngIf="isOnlinePayAvailable" class="filter-option" (click)="onChange('paymentType', 'cardOnline')">
              <app-checkbox [isChecked]="filter.paymentType.cardOnline"> </app-checkbox>
              {{ filterTitle.paymentType.cardOnline }}
            </div>
            <div *ngIf="isOnlinePayAvailable" class="filter-option" (click)="onChange('paymentType', 'cardSwipe')">
              <app-checkbox [isChecked]="filter.paymentType.cardSwipe"> </app-checkbox>
              {{ filterTitle.paymentType.cardSwipe }}
            </div>

            <div class="filter-option" (click)="onChange('paymentType', 'cheque')">
              <app-checkbox [isChecked]="filter.paymentType.cheque"> </app-checkbox>
              {{ filterTitle.paymentType.cheque }}
            </div>

            <div class="filter-option" (click)="onChange('paymentType', 'creditPayment')">
              <app-checkbox [isChecked]="filter.paymentType.creditPayment"> </app-checkbox>
              {{ filterTitle.paymentType.creditPayment }}
            </div>

            <div *ngIf="isRevenueRecognitionSettleEnabled" class="filter-option"
              (click)="onChange('paymentType', 'thirdParty')">
              <app-checkbox [isChecked]="filter.paymentType.thirdParty"> </app-checkbox>
              {{ filterTitle.paymentType.thirdParty }}
            </div>

            <div *ngIf="isRevenueRecognitionSettleEnabled && isWriteOffEnable" class="filter-option"
              (click)="onChange('paymentType', 'writeOff')">
              <app-checkbox [isChecked]="filter.paymentType?.writeOff"> </app-checkbox>
              {{ filterTitle.paymentType?.writeOff }}
            </div>

          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Payment Type -->

    <!-- Start Payment Group -->
    <div class="filter-pill payment-group" *ngIf="options.paymentGroup">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-8%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentGroup }">
            <div class="icon">
              <i class="fal fa-archive"></i>
            </div>
            <div class="filter-text w-120px text-overflow-ellipsis">
              <span *ngIf="filter?.paymentGroup?.refund
              && filter?.paymentGroup?.payment
              && filter?.paymentGroup?.void">
                {{ filterTitle?.paymentGroup?.all }}
              </span>

              <span
                *ngIf="filter?.paymentGroup?.refund && !filter?.paymentGroup?.void && !filter?.paymentGroup?.payment">
                {{ filterTitle?.paymentGroup?.refund }}
              </span>

              <span
                *ngIf="!filter?.paymentGroup?.refund && !filter?.paymentGroup?.void && filter?.paymentGroup?.payment">
                {{ filterTitle?.paymentGroup?.payment }}
              </span>

              <span *ngIf="filter?.paymentGroup?.void &&
              !filter?.paymentGroup?.payment &&
              !filter?.paymentGroup?.refund">
                {{ filterTitle?.paymentGroup?.void }}
              </span>

              <span *ngIf="filter?.paymentGroup?.refund === false
              && filter?.paymentGroup?.payment === false
              && filter?.paymentGroup?.void === false">
                {{ filterTitle?.paymentGroup?.all }}
              </span>

              <span
                *ngIf="(filter?.paymentGroup?.refund && filter?.paymentGroup?.payment && !filter?.paymentGroup?.void) ||
                            (filter?.paymentGroup?.refund && filter?.paymentGroup?.void && !filter?.paymentGroup?.payment) ||
                            (filter?.paymentGroup?.payment && filter?.paymentGroup?.void && !filter?.paymentGroup?.refund)">
                {{ filterTitle?.paymentGroup?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentGroup"></i>
              <i class="fal fa-times" *ngIf="filterApplied.paymentGroup" (click)="clearFilter('paymentGroup')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('paymentGroup', 'refund')">
              <app-checkbox [isChecked]="filter.paymentGroup.refund"> </app-checkbox>
              {{ filterTitle.paymentGroup.refund }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('paymentGroup', 'void')">
              <app-checkbox [isChecked]="filter.paymentGroup.void"> </app-checkbox>
              {{ filterTitle.paymentGroup.void }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('paymentGroup', 'payment')">
              <app-checkbox [isChecked]="filter.paymentGroup.payment"> </app-checkbox>
              {{ filterTitle.paymentGroup.payment }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Payment Group -->

    <!-- Start Location -->
    <div class="filter-pill location" *ngIf="options.location">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.location }">
            <div class="icon">
              <i class="fal fa-map-marker-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.location?.selected?.length === 0">{{ filterTitle?.location?.all }}</span>
              <span *ngIf="filter?.location?.selected?.length === 1">{{ (filter?.location?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.location?.selected?.length > 1">{{ filterTitle?.location?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.location"></i>
              <i class="fal fa-times" *ngIf="filterApplied.location" (click)="clearFilter('location')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="locations"
              (appChangeFilter)="changeLocationsFilter($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Items -->

    <!-- Start Quantity Type -->
    <div class="filter-pill quantity" *ngIf="options.qtyType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.qtyType }">
            <div class="icon">
              <i class="fal fa-boxes"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span> {{ getQuantityTypeTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.qtyType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.qtyType" (click)="clearFilter('qtyType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div *ngFor="let key of getFilterKeys('qtyType')" class="filter-option border-bottom-lightest"
              (click)="onChange('qtyType', key)">
              <app-checkbox [isChecked]="filter.qtyType[key]"> </app-checkbox>
              {{ filterTitle.qtyType[key] }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Quantity Type -->

    <!-- Start send status -->
    <div id="send-status-filter" class="filter-pill quantity" *ngIf="options.sendStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.sendStatus }">
            <div class="icon">
              <i class="fal fa-paper-plane"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span> {{ getSendStatusTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.sendStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.sendStatus" (click)="clearFilter('sendStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div *ngFor="let key of getSendFilterKeys('sendStatus')" class="filter-option border-bottom-lightest"
              (click)="onChange('sendStatus', key)">
              <app-checkbox [isChecked]="filter.sendStatus[key]"> </app-checkbox>
              {{ filterTitle.sendStatus[key] }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End send status -->

    <!-- Start paid status -->
    <div id="paid-status-filter" class="filter-pill quantity" *ngIf="options.paidStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paidStatus }">
            <div class="icon">
              <i class="fal fa-ballot-check"></i>
            </div>

            <div class="filter-text w-80px text-overflow-ellipsis">
              <span> {{ getPaidStatusTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.paidStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.paidStatus" (click)="clearFilter('paidStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div *ngFor="let key of getPaidFilterKeys('paidStatus')" class="filter-option border-bottom-lightest"
              (click)="onChange('paidStatus', key)">
              <app-checkbox [isChecked]="filter.paidStatus[key]"> </app-checkbox>
              {{ filterTitle.paidStatus[key] }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End send status -->

    <!-- Start Items -->
    <div class="filter-pill item-filter" *ngIf="options.items">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.items }">
            <div class="icon">
              <i class="fal fa-warehouse-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.items?.selected?.length === 0">{{ filterTitle?.items?.all }}</span>
              <span *ngIf="filter?.items?.selected?.length === 1">{{ (filter?.items?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.items?.selected?.length > 1">{{ filterTitle?.items?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.items"></i>
              <i class="fal fa-times" *ngIf="filterApplied.items" (click)="clearFilter('items')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="items" (appChangeFilter)="changeItemsFilter($event)">
            </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Items -->
    <!-- Start Supplier Type -->


    <!-- Start Warranty Type -->
    <div class="filter-pill customer-type" *ngIf="options.warrantyType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.warrantyType }">
            <div class="icon">
              <i class="fal fa-tasks"></i>
            </div>

            <div class="filter-text w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.warrantyType?.first && filter?.warrantyType?.replacement">
                {{ filterTitle?.warrantyType?.all }}
              </span>

              <span *ngIf="filter?.warrantyType?.first && !filter?.warrantyType?.replacement">
                {{ filterTitle?.warrantyType?.first }}
              </span>

              <span *ngIf="!filter?.warrantyType?.first && filter?.warrantyType?.replacement">
                {{ filterTitle?.warrantyType?.replacement }}
              </span>

              <span *ngIf="!filter?.warrantyType?.first && !filter?.warrantyType?.replacement">
                {{ filterTitle?.warrantyType?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.warrantyType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.warrantyType" (click)="clearFilter('warrantyType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('warrantyType', 'replacement')">
              <app-checkbox [isChecked]="filter.warrantyType.replacement"> </app-checkbox>
              {{ filterTitle.warrantyType.replacement }}
            </div>
            <div class="filter-option border-bottom-lightest" (click)="onChange('warrantyType', 'first')">
              <app-checkbox [isChecked]="filter.warrantyType.first"> </app-checkbox>
              {{ filterTitle.warrantyType.first }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Warranty Type -->

    <!-- Start item Type -->
    <div class="filter-pill customer-type" *ngIf="options.itemType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [closeAfterAction]="closeAfterAction" right="-3%">

        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.itemType }">
            <div class="icon">
              <i class="fal fa-warehouse-alt"></i>
            </div>

            <div *ngIf="options.warrantyType" class="filter-text w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.itemType?.tire && filter?.itemType?.part">
                {{ filterTitle?.itemType?.all }}
              </span>

              <span *ngIf="filter?.itemType?.tire && !filter?.itemType?.part">
                {{ filterTitle?.itemType?.tire }}
              </span>

              <span *ngIf="!filter?.itemType?.tire && filter?.itemType?.part">
                {{ filterTitle?.itemType?.part }}
              </span>

              <span *ngIf="!filter?.itemType?.tire && !filter?.itemType?.part">
                {{ filterTitle?.itemType?.all }}
              </span>
            </div>

            <div *ngIf="!options.warrantyType" class="filter-text w-110px text-overflow-ellipsis">
              <span
                *ngIf="filter?.itemType?.tire && filter?.itemType?.part && filter?.itemType?.labor && filter?.itemType?.sublet && filter?.itemType?.other && filter?.itemType?.tireStorage">
                {{ filterTitle?.itemType?.all }}
              </span>
              <span *ngIf="filter?.itemType?.tire">{{ filterTitle?.itemType?.tire }}</span>
              <span *ngIf="filter?.itemType?.part">{{ filterTitle?.itemType?.part }}</span>
              <span *ngIf="filter?.itemType?.labor">{{ filterTitle?.itemType?.labor }}</span>
              <span *ngIf="filter?.itemType?.sublet">{{ filterTitle?.itemType?.sublet }}</span>
              <span *ngIf="filter?.itemType?.other">{{ filterTitle?.itemType?.other }}</span>
              <span *ngIf="filter?.itemType?.tireStorage">{{ filterTitle?.itemType?.tireStorage }}</span>
              <span
                *ngIf="!filter?.itemType?.tire && !filter?.itemType?.part && !filter?.itemType?.labor && !filter?.itemType?.sublet && !filter?.itemType?.other && !filter?.itemType?.tireStorage">
                {{ filterTitle?.itemType?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.itemType" (click)="clearFilter('itemType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'tire')">
              <app-checkbox [isChecked]="filter.itemType.tire"></app-checkbox>
              {{ filterTitle.itemType.tire }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'part')">
              <app-checkbox [isChecked]="filter.itemType.part"></app-checkbox>
              {{ filterTitle.itemType.part }}
            </div>

            <ng-template *ngIf="!options.warrantyType">
              <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'labor')">
                <app-checkbox [isChecked]="filter.itemType.labor"></app-checkbox>
                {{ filterTitle.itemType.labor }}
              </div>

              <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'sublet')">
                <app-checkbox [isChecked]="filter.itemType.sublet"></app-checkbox>
                {{ filterTitle.itemType.sublet }}
              </div>

              <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'other')">
                <app-checkbox [isChecked]="filter.itemType.other"></app-checkbox>
                {{ filterTitle.itemType.other }}
              </div>

              <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'tireStorage')">
                <app-checkbox [isChecked]="filter.itemType.tireStorage"></app-checkbox>
                {{ filterTitle.itemType.tireStorage }}
              </div>
            </ng-template>

          </div>

        </ng-template>

      </app-content-overlay>

    </div>
    <!-- End item Type -->

    <!-- Start item source -->
    <div class="filter-pill company-name" *ngIf="options.genericFilter">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.genericFilter }">
            <div class="icon">
              <i class="fal" [ngClass]="genericFilterOptions?.iconClass"></i>
            </div>

            <div class="w-100 text-overflow-ellipsis" [ngStyle]="genericFilterOptions?.styleCss">
              <span *ngIf="filter?.genericFilter?.selected?.length === 0">{{ genericFilterOptions?.selectAllText
                }}</span>
              <span *ngIf="filter?.genericFilter?.selected?.length === 1">{{
                (filter?.genericFilter?.selected)[0][genericFilterOptions?.nameField] }}</span>
              <span *ngIf="filter?.genericFilter?.selected?.length > 1">{{ genericFilterOptions?.multipleSelectText ?
                genericFilterOptions?.multipleSelectText : 'Multiple Select' }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.genericFilter"></i>
              <i class="fal fa-times" *ngIf="filterApplied.genericFilter" (click)="clearFilter('genericFilter')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis" [ngStyle]="genericFilterOptions?.filterOverlayStyle">
            <app-multiple-filter scrollHeight="265px" [nameField]="genericFilterOptions?.nameField"
              [countField]="genericFilterOptions?.countField" [data]="genericFilterData"
              (appChangeFilter)="onSelectGenericFilter($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End item source -->

    <!-- Start item Category -->
    <div class="filter-pill company-name" *ngIf="options.itemCategory">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.itemCategory }">
            <div class="icon">
              <i class="fal fa-warehouse-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.itemCategory?.selected?.length === 0">{{ filterTitle?.itemCategory?.all }}</span>
              <span *ngIf="filter?.itemCategory?.selected?.length === 1">{{ (filter?.itemCategory?.selected)[0]?.name
                }}</span>
              <span *ngIf="filter?.itemCategory?.selected?.length > 1">{{ filterTitle?.itemCategory?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemCategory"></i>
              <i class="fal fa-times" *ngIf="filterApplied.itemCategory" (click)="clearFilter('itemCategory')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="itemCategorys"
              (appChangeFilter)="onSelectItemCategory($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End item Category -->

    <!-- Start Supplier name -->
    <div class="filter-pill company-name" *ngIf="options.supplier">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.supplier }">
            <div class="icon">
              <i class="fal fa-warehouse-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.supplier?.selected?.length === 0">{{ filterTitle?.supplier?.all }}</span>
              <span *ngIf="filter?.supplier?.selected?.length === 1">{{ (filter?.supplier?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.supplier?.selected?.length > 1">{{ filterTitle?.supplier?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.supplier"></i>
              <i class="fal fa-times" *ngIf="filterApplied.supplier" (click)="clearFilter('supplier')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="suppliers" [listData]="suppliers" [isSearchSelect]="true"
              (appChangeFilter)="onSelectSupplierName($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Supplier name -->

    <div class="filter-pill customer-type" *ngIf="options.supplierType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.supplierType }">
            <div class="icon">
              <i class="fal fa-warehouse-alt"></i>
            </div>

            <div class="filter-text w-110px text-overflow-ellipsis">
              <span *ngIf="filter?.supplierType?.internal && filter?.supplierType?.online">
                {{ filterTitle?.supplierType?.all }}
              </span>

              <span *ngIf="filter?.supplierType?.internal && !filter?.supplierType?.online">
                {{ filterTitle?.supplierType?.internal }}
              </span>

              <span *ngIf="!filter?.supplierType?.internal && filter?.supplierType?.online">
                {{ filterTitle?.supplierType?.online }}
              </span>

              <span *ngIf="!filter?.supplierType?.internal && !filter?.supplierType?.online">
                {{ filterTitle?.supplierType?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.supplierType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.supplierType" (click)="clearFilter('supplierType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('supplierType', 'internal')">
              <app-checkbox [isChecked]="filter.supplierType.internal"> </app-checkbox>
              {{ filterTitle.supplierType.internal }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('supplierType', 'online')">
              <app-checkbox [isChecked]="filter.supplierType.online"> </app-checkbox>
              {{ filterTitle.supplierType.online }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Supplier Type -->

    <!-- Start Fee type -->
    <div class="filter-pill customer-type" *ngIf="options.feeType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.feeType }">
            <div class="icon">
              <i class="fal fa-usd-circle"></i>
            </div>

            <div class="filter-text w-110px text-overflow-ellipsis">
              <span
                *ngIf="(filter?.feeType?.serviceLevel && filter?.feeType?.roLevel) || (filter?.feeType?.serviceLevel && filter?.feeType?.passThroughTax) || (filter?.feeType?.passThroughTax && filter?.feeType?.roLevel)">
                {{ filterTitle?.feeType?.all }}
              </span>

              <span
                *ngIf="filter?.feeType?.serviceLevel && !filter?.feeType?.roLevel && !filter?.feeType?.passThroughTax">
                {{ filterTitle?.feeType?.serviceLevel }}
              </span>

              <span
                *ngIf="!filter?.feeType?.serviceLevel && !filter?.feeType?.passThroughTax && filter?.feeType?.roLevel">
                {{ filterTitle?.feeType?.roLevel }}
              </span>

              <span
                *ngIf="!filter?.feeType?.serviceLevel && filter?.feeType?.passThroughTax && !filter?.feeType?.roLevel">
                {{ filterTitle?.feeType?.passThroughTax }}
              </span>

              <span
                *ngIf="!filter?.feeType?.serviceLevel && !filter?.feeType?.roLevel && !filter?.feeType?.passThroughTax">
                {{ filterTitle?.feeType?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.feeType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.feeType" (click)="clearFilter('feeType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('feeType', 'serviceLevel')">
              <app-checkbox [isChecked]="filter.feeType.serviceLevel"> </app-checkbox>
              {{ filterTitle.feeType.serviceLevel }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('feeType', 'roLevel')">
              <app-checkbox [isChecked]="filter.feeType.roLevel"> </app-checkbox>
              {{ filterTitle.feeType.roLevel }}
            </div>

            <div *ngIf="isPassThroughTaxEnable" class="filter-option border-bottom-lightest"
              (click)="onChange('feeType', 'passThroughTax')">
              <app-checkbox [isChecked]="filter.feeType.passThroughTax"> </app-checkbox>
              {{ filterTitle.feeType.passThroughTax }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Fee type -->

    <!-- Start Discount Value type -->
    <div class="filter-pill customer-type" *ngIf="options.orderDiscountType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderDiscountType }">
            <div class="icon">
              <i class="fal fa-usd-circle"></i>
            </div>

            <div class="filter-text w-110px text-overflow-ellipsis">
              <span *ngIf="filter?.orderDiscountType?.percentage && filter?.orderDiscountType?.dollarValue">
                {{ filterTitle?.orderDiscountType?.all }}
              </span>

              <span *ngIf="filter?.orderDiscountType?.percentage && !filter?.orderDiscountType?.dollarValue">
                {{ filterTitle?.orderDiscountType?.percentage }}
              </span>

              <span *ngIf="!filter?.orderDiscountType?.percentage && filter?.orderDiscountType?.dollarValue">
                {{ filterTitle?.orderDiscountType?.dollarValue }}
              </span>

              <span *ngIf="!filter?.orderDiscountType?.percentage && !filter?.orderDiscountType?.dollarValue">
                {{ filterTitle?.orderDiscountType?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderDiscountType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.orderDiscountType"
                (click)="clearFilter('orderDiscountType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('orderDiscountType', 'percentage')">
              <app-checkbox [isChecked]="filter?.orderDiscountType?.percentage"> </app-checkbox>
              {{ filterTitle?.orderDiscountType?.percentage }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('orderDiscountType', 'dollarValue')">
              <app-checkbox [isChecked]="filter?.orderDiscountType?.dollarValue"> </app-checkbox>
              {{ filterTitle?.orderDiscountType?.dollarValue }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Discount Value type -->

    <!-- Start Discount level type -->
    <div class="filter-pill customer-type" *ngIf="options.orderOn">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderOn }">
            <div class="icon">
              <i class="fal fa-usd-circle"></i>
            </div>

            <div class="filter-text w-110px text-overflow-ellipsis">
              <span *ngIf="filter?.orderOn?.serviceLevel && filter?.orderOn?.orderLevel">
                {{ filterTitle?.orderOn?.all }}
              </span>

              <span *ngIf="filter?.orderOn?.serviceLevel && !filter?.orderOn?.orderLevel">
                {{ filterTitle?.orderOn?.serviceLevel }}
              </span>

              <span *ngIf="!filter?.orderOn?.serviceLevel && filter?.orderOn?.orderLevel">
                {{ filterTitle?.orderOn?.orderLevel }}
              </span>

              <span *ngIf="!filter?.orderOn?.serviceLevel && !filter?.orderOn?.orderLevel">
                {{ filterTitle?.orderOn?.all }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderOn"></i>
              <i class="fal fa-times" *ngIf="filterApplied.orderOn" (click)="clearFilter('orderOn')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('orderOn', 'serviceLevel')">
              <app-checkbox [isChecked]="filter.orderOn.serviceLevel"> </app-checkbox>
              {{ filterTitle.orderOn.serviceLevel }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('orderOn', 'orderLevel')">
              <app-checkbox [isChecked]="filter.orderOn.orderLevel"> </app-checkbox>
              {{ filterTitle.orderOn.orderLevel }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Discount level type -->

    <!-- Start Date Filter -->
    <div id="statement-start-date-filter" class="filter-pill date-filter mr-4" *ngIf="options.date && hasStatement"
      [ngClass]="{ invisible: isDisableDateFilter }">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-17%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text text-overflow-ellipsis font-600" [ngClass]="{ 'w-80px': !options.roType }">
              {{ options.roType ? 'ROs paid (' + filterTitle.date + ')' : filterTitle.date }}
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down font-bold"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-170">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of dateFilterOption"
              (click)="onDateSelect(filterOption.id)" [ngClass]="{ active: filterApplied.date === filterOption.id }">
              {{ filterOption.title }}
              <span *ngIf="filterOption.id === 'this-week' || filterOption.id === 'last-week'"
                class="week-days-label">(Mon - Sun)</span>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
      <span class="date-divider" *ngIf="!notShowMobileView"></span>
    </div>

    <div class="report-filter-date width-168p" *ngIf="options.dateRang && hasStatement"
      [ngClass]="{ 'width-240': path === '/reports/all-payments' }">
      <div class="dashboard-date flex-start-center mr-2"
        [ngClass]="{ 'ml-1': path !== '/reports/all-payments', 'mt-8px' : path === '/reports/technician-attendance-log', 'mt-8px' : path === '/reports/technician-attendance-log-details' }">
        <i class="fal fa-chevron-left font-gray mr-1 mt-3 pointer" *ngIf="
            showDateNavigation &&
            (filterApplied.date === 'custom' ||
              ['technician-attendance-log'].includes(id) ||
              (['technician-attendance-log-details'].includes(id) && this.filterTitle.date !== 'All time' && this.filterTitle.date !== 'custom'))
          " (click)="dateBack()"></i>

        <div class="date-label-key" [ngClass]="{
            'flex-center-center': path !== '/reports/all-payments',
            'mt-2': path !== 'create-statement',
            'min-width-150': path === '/reports/technician-activity-records' || path === '/reports/technician-summary',
            'dashboard-date-inner-alignment': path === '/reports/all-payments',
            'min-width-301 mt-1': this.filterTitle.date && dateType,
            'commission-report-date': options.roType,
            'dashboard-date-inner': !options.roType
          }">
          <p class="m-0 font-600" *ngIf="dateType">
            <!-- <i class="fal fa-calendar-alt pl-1 mr-2"></i> -->
            <span class="font-11">Filter by:</span>
            <span class="font-11 font-black pl-1 font-600">{{ dateType }}</span>
            <span *ngIf="dateRangeHoverInfo"><i class="far fa-info-circle ml-1" tooltipPosition="top"
                [pTooltip]="dateRangeHoverInfo"></i></span>
          </p>
          <!-- <p class="m-0 font-600" *ngIf="!dateType"><i class="fal fa-calendar-alt pl-1 mr-2"></i>Invoice Date:</p> -->
          <div class="date-key" [ngClass]="{ 'min-width-200': dateType, 'mt-1': !dateType }">
            <!-- <span class="mr-2" *ngIf="dateType">{{ dateType }}</span> -->
            <!-- <span class="date-title mr-1" *ngIf="!options.roType">Invoice Date:</span> -->
            <span class="title font-black font-11 font-600" *ngIf="dateTitle">( {{ dateTitle }} )</span>
          </div>
        </div>

        <i class="fal fa-chevron-right mt-3 font-gray ml-1" *ngIf="
            showDateNavigation &&
            (filterApplied.date === 'custom' ||
              ['technician-attendance-log'].includes(id) ||
              (['technician-attendance-log-details'].includes(id) && this.filterTitle.date !== 'All time' && this.filterTitle.date !== 'custom'))
          " (click)="dateNext()"></i>
      </div>
    </div>
    <!-- End Date Filter -->
  </div>

  <div *ngIf="options.finalizeRevenue" class="finalize-filter-pill">
    <div class="flex-start-center label-12">
      <span class="p-profitibilty mr-2 font-14 font-600 font-gray-45">Type:</span>
      <span class="radio-inline mt-1">
        <app-radio-button [selectedValue]="filter?.isFilterByFinalizeDate" label="Finalize date" [value]="true"
          (appChange)="onChange('isFilterByFinalizeDate', 'true')"></app-radio-button>
      </span>

      <span class="ml-2 mt-1">
        <app-radio-button [selectedValue]="filter?.isFilterByFinalizeDate" label="Invoice date" [value]="false"
          (appChange)="onChange('isFilterByFinalizeDate', 'false')"></app-radio-button>
      </span>
    </div>
  </div>

  <div class="report-filter-inner filter-mobile" *ngIf="!notShowMobileView">
    <!-- Export Button -->
    <div class="report-export export-btn exp-btn item-sold" *ngIf="hasExport && path !== '/reports/enhance-item-sold'">
      <button class="btn btn-primary btn-submit" (click)="onExport()"><i
          class="fal fa-file-upload mr-1"></i><span>Export</span></button>
    </div>

    <!-- export dorpdown for item-sold -->
    <div class="report-export export-btn exp-btn item-sold-export"
      *ngIf="hasExport && path === '/reports/enhance-item-sold'">
      <!-- Dropdown Button -->
      <div class="dropdown">
        <button class="btn btn-primary btn-submit dropdown-toggle" type="button" id="exportDropdown"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fal fa-file-upload mr-1"></i><span>Export</span>
        </button>

        <!-- Dropdown Menu -->
        <div class="dropdown-menu export-main" aria-labelledby="exportDropdown">
          <!-- First Export Option -->
          <!-- [pTooltip]="'Exports the main summary report'"
          tooltipPosition="top" tooltipStyleClass="contact-status-tooltip text-center" -->
          <button class="dropdown-item" (click)="onExport()">
            Export Summary <i class="fal fa-arrow-right"></i>
          </button>

          <!-- Second Export Option -->
          <div class="btn-group w-100">
            <button (click)="$event.stopPropagation(); handleExportDetailToggle()"
              class="dropdown-item mb-0 dropdown-toggle" type="button"
              [pTooltip]="'Export item-level drilldown data for the selected item type'" tooltipPosition="top"
              tooltipStyleClass="contact-status-tooltip text-center">
              <span>
                Export Details
              </span>
              <i *ngIf="toggleExportDetails" class="fal fa-chevron-down"></i>
              <i *ngIf="!toggleExportDetails" class="fal fa-chevron-right"></i>
            </button>

            <!-- <button type="button" class="btn dropdown-toggle dropdown-toggle-split" id="exportDetailsOptions"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="$event.stopPropagation();">
              <i class="fal fa-chevron-down"></i>
            </button> -->

            <div *ngIf="toggleExportDetails" class="dropdown-menu export-inner show"
              aria-labelledby="exportDetailsOptions" (click)="$event.stopPropagation();">
              <div class="export-dropdown-options">
                <label class="font-14 font-gray-600 font-400 mb-1">Select Item Type:</label>
                <ul class="export-options-list p-0 mb-0">
                  <li class="export-options-list-item">
                    <button (click)="exportItemItem('part', $event)">Parts</button>
                  </li>
                  <li class="export-options-list-item">
                    <button (click)="exportItemItem('labor', $event)">Labor</button>
                  </li>
                  <li class="export-options-list-item">
                    <button (click)="exportItemItem('tire', $event)">Tire</button>
                  </li>
                  <li class="export-options-list-item">
                    <button (click)="exportItemItem('tireStorage', $event)">Tire Storage</button>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- export dropdowm for item-sold end  -->

    <div class="report-export export-btn exp-btn" *ngIf="hasExportMidas">
      <div class="dropdown">
        <button class="btn btn-primary btn-submit dropdown-toggle" type="button" id="exportDropdown"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fal fa-file-upload mr-1"></i><span>Export</span>
        </button>

        <div class="dropdown-menu" aria-labelledby="exportDropdown">
          <button class="dropdown-item" (click)="onExport()">
            <i class="fal fa-file-alt mr-1"></i> Export CSV
          </button>
          <button class="dropdown-item" (click)="onExportXML()">
            <i class="fal fa-code mr-1"></i> Export XML
          </button>
        </div>
      </div>
    </div>

    <!-- Print Button -->
    <div class="report-export" *ngIf="hasPrint">
      <button class="btn btn-submit flex-center-center print-btn  print-btn-with-exp">
        <span (click)="onExport(true)"><i class="fal fa-print mr-1"></i>Print to PDF</span>
        <span (click)="$event.stopPropagation(); viewPrintLogs()">
          <i class="fal fa-history"></i>
        </span>
      </button>
    </div>

    <div class="report-export export-btn exp-btn" *ngIf="hasSchedule && id !== 'royalty'">
      <button class="btn btn-primary btn-submit  print-btn-with-exp" (click)="onExport(true)"><i
          class="fal fa-print mr-2"></i><span>Print</span></button>
    </div>
    <!-- Schedule Button -->
    <div class="report-export" *ngIf="hasSchedule">
      <button class="btn btn-submit flex-center-center print-btn print-btn-with-exp"
        [disabled]="isDisableScheduleBtn && id !== 'royalty'" (click)="onSchedule()">
        <span><i class="fal fa-calendar-alt"></i>&nbsp;&nbsp; Schedule</span>
      </button>
    </div>
    <!-- Export Button End-->
    <div class="report-export export-btn exp-btn responsive-filter-btn">
      <button class="btn btn-border" (click)="filterDrawer = true"
        *ngIf="!['technician-attendance-log','technician-attendance-log-details'].includes(id)">
        <i class="fal fa-filter"></i> Filter <span class="filter-no">{{ filterArrayCount }}</span>
      </button>
    </div>
  </div>

  <div class="filter-drawer" [ngClass]="filterDrawer ? 'active' : ''" *ngIf="!notShowMobileView">
    <div class="drawer-section">
      <div class="drawer-header">
        <h3>Filter</h3>
        <button class="btn btn-border px-2 py-0 b-0" (click)="filterDrawer = false">
          <i class="fal fa-times"></i>
        </button>
      </div>

      <div class="drawer-main">
        <div class="drawer-body">
          <div class="single-filter" *ngIf="options.date" [ngClass]="{ dnone: isDisableDateFilter }">
            <h4>Date Filter</h4>
            <!-- Start Date Filter -->
            <div class="filter-pill date-filter">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-17%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper">
                    <div class="icon">
                      <i class="fal fa-calendar-alt"></i>
                    </div>
                    <div class="filter-text w-80px text-overflow-ellipsis">
                      {{ filterTitle.date }}
                    </div>
                    <div class="filter-cross">
                      <i class="fal fa-chevron-down"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-170">
                    <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of dateFilterOption"
                      (click)="onDateSelect(filterOption.id)"
                      [ngClass]="{ active: filterApplied.date === filterOption.id }">
                      {{ filterOption.title }}
                      <span *ngIf="filterOption.id === 'this-week' || filterOption.id === 'last-week'"
                        class="week-days-label">(Mon - Sun)</span>
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
          </div>

          <div class="single-filter" *ngIf="options.dateRang">
            <h4>Selected Date</h4>
            <div class="report-filter-date" [ngClass]="{ 'width-165': path === '/reports/all-payments' }">
              <div class="dashboard-date flex-start-center mr-2"
                [ngClass]="{ 'ml-1': path !== '/reports/all-payments' }">
                <i class="fal fa-chevron-left font-gray mr-1 pointer" *ngIf="
                    showDateNavigation &&
                    (filterApplied.date === 'custom' ||
                      ['technician-attendance-log'].includes(id) ||
                      (['technician-attendance-log-details'].includes(id) && this.filterTitle.date !== 'All time' && this.filterTitle.date !== 'custom'))
                  " (click)="dateBack()"></i>

                <div class="dashboard-date-inner" [ngClass]="{
                    'flex-center-center': path !== '/reports/all-payments',
                    'min-width-150': path === '/reports/technician-activity-records' || path === '/reports/technician-summary',
                    'dashboard-date-inner-alignment': path === '/reports/all-payments',
                    'min-width-300': this.filterTitle.date && dateType
                  }">
                  <i class="fal fa-calendar-alt pl-1 mr-2"></i>
                  <span class="mr-2" *ngIf="dateType">{{ dateType }}</span>
                  <span class="date-title mr-1">Invoice Date:</span>
                  <span class="title">({{ dateTitle }})</span>
                </div>

                <i class="fal fa-chevron-right font-gray ml-1" *ngIf="
                    showDateNavigation &&
                    (filterApplied.date === 'custom' ||
                      ['technician-attendance-log'].includes(id) ||
                      (['technician-attendance-log-details'].includes(id) && this.filterTitle.date !== 'All time' && this.filterTitle.date !== 'custom'))
                  " (click)="dateNext()"></i>
              </div>
            </div>
            <!-- End Date Filter -->
          </div>
          <div class="single-filter" *ngIf="canSwitchLocation && isMultiLocationEnabled && hasMultiLocationFilter">
            <h4>Multilocation</h4>
            <!-- ----Multilocation Filter-------- -->
            <div>
              <app-shop-location-dropdown class="d-inline-block w-100" type="item-return"
                [(preSelectedLocationsIds)]="preSelectedLocationsIds" (filterChange)="onMultiLocationChange($event)">
              </app-shop-location-dropdown>
            </div>
          </div>

          <div class="single-filter" *ngIf="options.workflow">
            <h4>Workflow</h4>
            <!-- Start Workflow -->
            <div class="filter-pill workflow">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-12%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.workflow }">
                    <div class="icon">
                      <i class="fal fa-stream"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span>{{ filterTitle?.workflow }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.workflow"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.workflow" (click)="clearFilter('workflow')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160 text-overflow-ellipsis">
                    <app-single-filter scrollHeight="260px" valueField="id" [data]="workFlowStatuses"
                      [selectedValue]="filter.workflow" (appChangeFilter)="onSelectWorkflow($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Workflow -->
          </div>

          <div class="single-filter" *ngIf="options.singleMonth" [ngClass]="{ dnone: isDisableDateFilter }">
            <h4>Date Filter</h4>
            <!-- Start Date Filter -->
            <div class="filter-pill date-filter">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-17%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper">
                    <div class="icon">
                      <i class="fal fa-calendar-alt"></i>
                    </div>
                    <div class="filter-text w-80px text-overflow-ellipsis">
                      {{ filterTitle.date }}
                    </div>
                    <div class="filter-cross">
                      <i class="fal fa-chevron-down"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-170">
                    <div class="filter-option border-bottom-lightest"
                      *ngFor="let filterOption of singleMonthFilterOption" (click)="onDateSelect(filterOption.id)"
                      [ngClass]="{ active: filterApplied.date === filterOption.id }">
                      {{ filterOption.title }}

                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
          </div>

          <div class="single-filter" *ngIf="options.taxItemType">
            <h4>Tax Item</h4>
            <!-- Start Item Tax type -->
            <div class="filter-pill company-name">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.taxItemType }">
                    <div class="icon">
                      <i class="fal fa-box"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <span *ngIf="filter?.taxItemType?.selected?.length === 0">{{ filterTitle?.taxItemType?.all
                        }}</span>
                      <span *ngIf="filter?.taxItemType?.selected?.length === 1">{{
                        (filter?.taxItemType?.selected)[0]?.name }}</span>
                      <span *ngIf="filter?.taxItemType?.selected?.length > 1">{{ filterTitle?.taxItemType?.multiple
                        }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.taxItemType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.taxItemType"
                        (click)="clearFilter('taxItemType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-180 text-overflow-ellipsis">
                    <app-multiple-filter scrollHeight="265px" [data]="taxItemTypes"
                      (appChangeFilter)="onSelectItemTaxTypeName($event)"> </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End  Item Tax type -->
          </div>

          <div class="single-filter" *ngIf="options.taxCode">
            <h4>Tax Code</h4>
            <!-- Start Tax code -->
            <div class="filter-pill taxCode">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-12%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.taxCode }">
                    <div class="icon">
                      <i class="fal fa-stream"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span *ngIf="!filter?.taxCode?._id">Tax code</span>
                      <span *ngIf="filter?.taxCode?._id">{{ filter?.taxCode?.name }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.taxCode"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.taxCode" (click)="clearFilter('taxCode')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160 text-overflow-ellipsis">
                    <app-single-filter scrollHeight="260px" valueField="_id" [data]="taxCodes"
                      [selectedValue]="filter.taxCode" (appChangeFilter)="onTaxCodeSelect($event)"> </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Tax code -->
          </div>

          <div class="single-filter" *ngIf="options.orderStatus">
            <h4>Order Status</h4>
            <!-- Start Order Status -->
            <div class="filter-pill order-status">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-9%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderStatus }">
                    <div class="icon">
                      <i class="fal fa-tasks"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <span *ngIf="filter?.orderStatus?.estimate && filter?.orderStatus?.invoice">
                        {{ filterTitle?.orderStatus?.all }}
                      </span>

                      <span *ngIf="filter?.orderStatus?.estimate && !filter?.orderStatus?.invoice">
                        {{ filterTitle?.orderStatus?.estimate }}
                      </span>

                      <span *ngIf="!filter?.orderStatus?.estimate && filter?.orderStatus?.invoice">
                        {{ filterTitle?.orderStatus?.invoice }}
                      </span>

                      <span *ngIf="!filter?.orderStatus?.estimate && !filter?.orderStatus?.invoice">
                        {{ filterTitle?.orderStatus?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.orderStatus"
                        (click)="clearFilter('orderStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('orderStatus', 'estimate')">
                      <app-checkbox [isChecked]="filter.orderStatus.estimate"> </app-checkbox>
                      {{ filterTitle.orderStatus.estimate }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('orderStatus', 'invoice')">
                      <app-checkbox [isChecked]="filter.orderStatus.invoice"> </app-checkbox>
                      {{ filterTitle.orderStatus.invoice }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Order Status -->
          </div>

          <div class="single-filter" *ngIf="options.roStatus">
            <h4>RO Status</h4>
            <!-- Start RO Status -->
            <div class="filter-pill order-status">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-9%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.roStatus }">
                    <div class="icon">
                      <i class="fal fa-tasks"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <!-- Show "All" when all filters are selected -->
                      <span
                        *ngIf="filter?.roStatus?.estimate && filter?.roStatus?.invoice && filter?.roStatus?.finalized">
                        {{ filterTitle?.roStatus?.all }}
                      </span>

                      <!-- Show individual filter names if only one is selected -->
                      <span
                        *ngIf="filter?.roStatus?.estimate && !filter?.roStatus?.invoice && !filter?.roStatus?.finalized">
                        {{ filterTitle?.roStatus?.estimate }}
                      </span>

                      <span
                        *ngIf="filter?.roStatus?.invoice && !filter?.roStatus?.estimate && !filter?.roStatus?.finalized">
                        {{ filterTitle?.roStatus?.invoice }}
                      </span>

                      <span
                        *ngIf="filter?.roStatus?.finalized && !filter?.roStatus?.estimate && !filter?.roStatus?.invoice">
                        {{ filterTitle?.roStatus?.finalized }}
                      </span>

                      <!-- Show "Multiple Status" -->
                      <span
                        *ngIf="(filter?.roStatus?.estimate && filter?.roStatus?.invoice && !filter?.roStatus?.finalized && isRevenueRecognitionSettleEnabled) ||
                               (filter?.roStatus?.estimate && filter?.roStatus?.finalized && !filter?.roStatus?.invoice) ||
                               (filter?.roStatus?.invoice && filter?.roStatus?.finalized && !filter?.roStatus?.estimate)">
                        {{ filterTitle?.roStatus?.multiple }}
                      </span>

                      <!-- Show "All" if no filters are selected -->
                      <span
                        *ngIf="!filter?.roStatus?.estimate && !filter?.roStatus?.invoice && !filter?.roStatus?.finalized">
                        {{ filterTitle?.roStatus?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.roStatus"></i>
                      <i class="fal fa-times hide-for-tech-sumary" *ngIf="filterApplied.roStatus"
                        (click)="clearFilter('roStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('roStatus', 'estimate')">
                      <app-checkbox [isChecked]="filter.roStatus.estimate"> </app-checkbox>
                      {{ filterTitle.roStatus.estimate }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('roStatus', 'invoice')">
                      <app-checkbox [isChecked]="filter.roStatus.invoice"> </app-checkbox>
                      {{ filterTitle.roStatus.invoice }}
                    </div>

                    <div *ngIf="isRevenueRecognitionSettleEnabled" class="filter-option border-bottom-lightest"
                      (click)="onChange('roStatus', 'finalized')">
                      <app-checkbox [isChecked]="filter.roStatus.finalized"> </app-checkbox>
                      {{ filterTitle.roStatus.finalized }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Order Status -->
          </div>

          <div class="single-filter" *ngIf="options.orderingStatus">
            <h4>Ordering Status</h4>
            <!-- Start Ordering status -->
            <div class="filter-pill payment-type-1">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderingStatus }">
                    <div class="icon">
                      <i class="fal fa-clipboard-check"></i>
                    </div>

                    <div class="filter-text w-120px text-overflow-ellipsis mr-1">
                      <span>{{ showOrderingStatusTitle() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderingStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.orderingStatus"
                        (click)="clearFilter('orderingStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay" let-close="close">
                  <div class="filter-overlay w-160">
                    <div class="filter-option" (click)="onChange('orderingStatus', 'unordered')">
                      <app-checkbox [isChecked]="filter.orderingStatus.unordered"> </app-checkbox>
                      {{ filterTitle.orderingStatus.unordered }}
                    </div>

                    <div class="filter-option" (click)="onChange('orderingStatus', 'ordered')">
                      <app-checkbox [isChecked]="filter.orderingStatus.ordered"> </app-checkbox>
                      {{ filterTitle.orderingStatus.ordered }}
                    </div>
                    <div class="filter-option" (click)="onChange('orderingStatus', 'delivered')">
                      <app-checkbox [isChecked]="filter.orderingStatus.delivered"> </app-checkbox>
                      {{ filterTitle.orderingStatus.delivered }}
                    </div>
                    <div class="filter-option" (click)="onChange('orderingStatus', 'cancelled')">
                      <app-checkbox [isChecked]="filter.orderingStatus.cancelled"> </app-checkbox>
                      {{ filterTitle.orderingStatus.cancelled }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Ordering status -->
          </div>

          <div class="single-filter" *ngIf="options.paymentTerms">
            <h4>Payment Terms</h4>
            <!-- Start payment Term -->
            <div class="filter-pill payment-type-1">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentTerms }">
                    <div class="icon">
                      <i class="fal fa-file-invoice"></i>
                    </div>

                    <div class="filter-text w-120px text-overflow-ellipsis mr-1">
                      <span>{{ showPaymenTermsTitle() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentTerms"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.paymentTerms"
                        (click)="clearFilter('paymentTerms')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay" let-close="close">
                  <div class="filter-overlay w-160">
                    <div class="filter-option" (click)="onChange('paymentTerms', 'payable')">
                      <app-checkbox [isChecked]="filter.paymentTerms.payable"> </app-checkbox>
                      {{ filterTitle.paymentTerms.payable }}
                    </div>

                    <div class="filter-option" (click)="onChange('paymentTerms', 'cod')">
                      <app-checkbox [isChecked]="filter.paymentTerms.cod"> </app-checkbox>
                      {{ filterTitle.paymentTerms.cod }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End payment term -->
          </div>

          <div class="single-filter" *ngIf="options.orderingMethods">
            <h4>Ordering Method</h4>
            <!-- Start Ordering methods -->
            <div class="filter-pill payment-type-1">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderingMethods }">
                    <div class="icon">
                      <i class="fal fa-file-alt"></i>
                    </div>

                    <div class="filter-text w-120px text-overflow-ellipsis mr-1">
                      <span>{{ showOrderingMethodsTitle() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderingMethods"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.orderingMethods"
                        (click)="clearFilter('orderingMethods')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay" let-close="close">
                  <div class="filter-overlay w-160">
                    <div class="filter-option" (click)="onChange('orderingMethods', 'online')">
                      <app-checkbox [isChecked]="filter.orderingMethods.online"> </app-checkbox>
                      {{ filterTitle.orderingMethods.online }}
                    </div>

                    <div class="filter-option" (click)="onChange('orderingMethods', 'offline')">
                      <app-checkbox [isChecked]="filter.orderingMethods.offline"> </app-checkbox>
                      {{ filterTitle.orderingMethods.offline }}
                    </div>
                    <div class="filter-option" (click)="onChange('orderingMethods', 'inventory')">
                      <app-checkbox [isChecked]="filter.orderingMethods.inventory"> </app-checkbox>
                      {{ filterTitle.orderingMethods.inventory }}
                    </div>
                    <div class="filter-option" (click)="onChange('orderingMethods', 'provisional')">
                      <app-checkbox [isChecked]="filter.orderingMethods.provisional"> </app-checkbox>
                      {{ filterTitle.orderingMethods.provisional }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Ordering methods -->
          </div>

          <div class="single-filter" *ngIf="options.archives">
            <h4>Archives</h4>
            <!-- Start Archives -->
            <div class="filter-pill archives">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-8%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.archives }">
                    <div class="icon">
                      <i class="fal fa-archive"></i>
                    </div>

                    <div class="filter-text w-70px text-overflow-ellipsis">
                      <span *ngIf="filter?.archives?.archived && filter?.archives?.unArchived">
                        {{ filterTitle?.archives?.all }}
                      </span>

                      <span *ngIf="filter?.archives?.archived && !filter?.archives?.unArchived">
                        {{ filterTitle?.archives?.archived }}
                      </span>

                      <span *ngIf="!filter?.archives?.archived && filter?.archives?.unArchived">
                        {{ filterTitle?.archives?.unArchived }}
                      </span>

                      <span *ngIf="filter?.archives?.archived === false && filter?.archives?.unArchived === false">
                        {{ filterTitle?.archives?.all }}
                      </span>
                    </div>
                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.archives"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.archives" (click)="clearFilter('archives')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-140">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('archives', 'archived')">
                      <app-checkbox [isChecked]="filter.archives.archived"> </app-checkbox>
                      {{ filterTitle.archives.archived }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('archives', 'unArchived')">
                      <app-checkbox [isChecked]="filter.archives.unArchived"> </app-checkbox>
                      {{ filterTitle.archives.unArchived }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Archives -->
          </div>

          <div class="single-filter" *ngIf="options.paymentStatus">
            <h4>Payment Status</h4>
            <!-- Start Payment Status -->
            <div class="filter-pill payment-status">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-18%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentStatus }">
                    <div class="icon">
                      <i class="fal fa-user-hard-hat"></i>
                    </div>

                    <div class="filter-text w-70px text-overflow-ellipsis">
                      {{ filterTitle?.paymentStatus }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.paymentStatus"
                        (click)="clearFilter('paymentStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-single-filter [data]="paymentStatusOptions" valueField="id"
                      [selectedValue]="filter.paymentStatus" scrollHeight="260px"
                      (appChangeFilter)="onSelectPaymentStatus($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Payment Status -->
          </div>

          <!-- creditMemo -->
          <div class="single-filter" *ngIf="options.creditMemo">
            <h4>Payment Status</h4>
            <!-- Start Payment Status -->
            <div class="filter-pill payment-status">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-18%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.creditMemo }">
                    <div class="icon">
                      <i class="fal fa-user-hard-hat"></i>
                    </div>

                    <div class="filter-text w-70px text-overflow-ellipsis">
                      {{ filterTitle?.creditMemo }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.creditMemo"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.creditMemo" (click)="clearFilter('creditMemo')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-single-filter [data]="paymentStatusOptions" valueField="id" [selectedValue]="filter.creditMemo"
                      scrollHeight="260px" (appChangeFilter)="onSelectCreditStatus($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Payment Status -->
          </div>
          <!-- credit memo end -->

          <div class="single-filter" *ngIf="options.itemPaymentStatus">
            <h4>Item Payment Status</h4>
            <!-- Start Item Payment Status -->
            <div class="filter-pill payment-status">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-18%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.itemPaymentStatus }">
                    <div class="icon">
                      <i class="fal fa-user-hard-hat"></i>
                    </div>

                    <div class="filter-text w-70px text-overflow-ellipsis">
                      {{ filterTitle?.itemPaymentStatus }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemPaymentStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.itemPaymentStatus"
                        (click)="clearFilter('itemPaymentStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-single-filter [data]="itemPaymentStatusOptions" valueField="id"
                      [selectedValue]="filter.itemPaymentStatus" scrollHeight="260px"
                      (appChangeFilter)="onSelectItemPaymentStatus($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Payment Status -->
          </div>

          <div class="single-filter" *ngIf="options.statementStatus">
            <h4>Start Statement</h4>
            <!-- Start Statemnet -->
            <div class="filter-pill rating">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-1%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.statementStatus }">
                    <div class="icon">
                      <i class="fal fa-receipt"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      {{ filterTitle.statementTitle }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.statementStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.statementStatus"
                        (click)="clearFilter('statementStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-140">
                    <app-single-filter scrollHeight="260px" valueField="id" [data]="statmentOptions"
                      [selectedValue]="this.filter.statementStatus" (appChangeFilter)="onSelectStatemnet($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Statemnet -->
          </div>

          <div class="single-filter" *ngIf="options.category">
            <h4>Canned Service</h4>
            <!-- Start Canned Service Category -->
            <div class="filter-pill canned-service">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.category }">
                    <div class="icon">
                      <i class="fal fa-th"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      {{ filterTitle.category }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.category"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.category" (click)="clearFilter('category')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-single-filter scrollHeight="260px" valueField="id" [data]="categories"
                      [selectedValue]="this.filter.category" (appChangeFilter)="onSelectCategory($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Canned Service Category -->
          </div>

          <div class="single-filter" *ngIf="options.activity">
            <h4>Activity Type</h4>
            <!-- Start Activity Type -->
            <div class="filter-pill activity-type" *ngIf="options.activity">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.activity }">
                    <div class="icon">
                      <i class="fal fa-stopwatch"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span *ngIf="filter?.activity?.inspections && filter?.activity?.services">
                        {{ filterTitle?.activity?.all }}
                      </span>

                      <span *ngIf="filter?.activity?.inspections && !filter?.activity?.services">
                        {{ filterTitle?.activity?.inspections }}
                      </span>

                      <span *ngIf="!filter?.activity?.inspections && filter?.activity?.services">
                        {{ filterTitle?.activity?.services }}
                      </span>

                      <span *ngIf="!filter?.activity?.inspections && !filter?.activity?.services">
                        {{ filterTitle?.activity?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.activity"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.activity" (click)="clearFilter('activity')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('activity', 'inspections')">
                      <app-checkbox [isChecked]="filter.activity.inspections"> </app-checkbox>
                      {{ filterTitle.activity.inspections }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('activity', 'services')">
                      <app-checkbox [isChecked]="filter.activity.services"> </app-checkbox>
                      {{ filterTitle.activity.services }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Activity Type -->
          </div>

          <div class="single-filter" *ngIf="options.ratings">
            <h4>Ratings</h4>
            <!-- Start Ratings -->
            <div class="filter-pill rating">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-1%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.rating }">
                    <div class="icon">
                      <i class="fal fa-star"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      {{ filterTitle.rating }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.rating"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.rating" (click)="clearFilter('rating')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-140">
                    <app-single-filter scrollHeight="260px" valueField="id" [data]="ratingOptions"
                      [selectedValue]="this.filter.rating" (appChangeFilter)="onSelectRating($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Ratings -->
          </div>

          <div class="single-filter" *ngIf="options.tech">
            <h4>Technicians</h4>
            <!-- Start Technicians -->
            <div class="filter-pill technician">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-8%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tech }">
                    <div class="icon">
                      <i class="fal fa-user-hard-hat"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      {{ techNameDisplay() }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.tech"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.tech" (click)="clearFilter('tech')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-single-filter valueField="id" scrollHeight="198px" [data]="technicians"
                      [selectedValue]="filter.tech" (appChangeFilter)="onSelectTechnician($event)"> </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Technicians -->
          </div>

          <div class="single-filter pt-1 SalesGroupFilter" *ngIf="options.salesGroup">
            <h4>Sales group</h4>
            <!-- Start Technicians -->
            <div class="filter-pill technician">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-8%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.salesGroup }">
                    <div class="icon">
                      <!-- <i class="fal fa-user-hard-hat"></i> -->
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      {{ salesGroupDisplay() }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.salesGroup"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.salesGroup" (click)="clearFilter('salesGroup')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-single-filter valueField="_id" scrollHeight="198px" [data]="salesGroupsResults"
                      [selectedValue]="filter.salesGroup" (appChangeFilter)="onSelectSalesGroup($event)"
                      (scroll)="onScrollGetSalesGroup()">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Technicians -->
          </div>

          <!-- sales code -->
          <div class="single-filter pt-1 SalesCodeFilter" *ngIf="options.salesCode">
            <h4>Sales Code</h4>
            <!-- Start Technicians -->
            <div class="filter-pill technician">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-8%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.salesCode }">
                    <div class="icon">
                      <!-- <i class="fal fa-user-hard-hat"></i> -->
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      {{ salesCodeDisplay() }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.salesCode"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.salesCode" (click)="clearFilter('salesCode')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-single-filter valueField="_id" nameField="title" scrollHeight="198px" [data]="salesCodeResults"
                      [selectedValue]="filter.salesCode" (appChangeFilter)="onSelectSalesCode($event)" (scroll)="onScrollGetSalesCode()">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Technicians -->
          </div>
          <!-- sales code end -->

          <!-- Start Service Advisor -->
          <div class="single-filter pt-1" *ngIf="options.serviceWriter">
            <h4>Service Advisor</h4>
            <div class="filter-pill advisor">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-8%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.serviceWriter }">
                    <div class="icon">
                      <i class="fal fa-user-hard-hat"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      {{ serviceWriterDisplay() }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.serviceWriter"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.serviceWriter"
                        (click)="clearFilter('serviceWriter')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-single-filter valueField="id" scrollHeight="260px" [data]="serviceWriterUsers"
                      [selectedValue]="filter.serviceWriter" (appChangeFilter)="onSelectServiceWriter($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Service Advisor -->
          </div>
          <!-- Ends Service Advisor -->

          <div class="single-filter" *ngIf="options.lastSold">
            <h4>Last Sold</h4>
            <!-- Start Last sold -->
            <div class="filter-pill last-sold">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-30%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.lastSold }">
                    <div class="icon">
                      <i class="fal fa-calendar-week"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      {{ filterTitle.lastSold }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.lastSold"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.lastSold" (click)="clearFilter('lastSold')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-220">
                    <app-single-filter scrollHeight="198px" valueField="id" [selectedValue]="this.filter.lastSold"
                      [data]="lastSoldOptions" (appChangeFilter)="onSelectLastSold($event)">
                    </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Last sold -->
          </div>

          <div class="single-filter" *ngIf="options.customerType">
            <h4>Customer Type</h4>
            <!-- Start Customer Type -->
            <div class="filter-pill customer-type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.customerType }">
                    <div class="icon">
                      <i class="fal fa-user"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span *ngIf="filter?.customerType?.newCustomers && filter?.customerType?.repeatCustomers">
                        {{ filterTitle?.customerType?.all }}
                      </span>

                      <span *ngIf="filter?.customerType?.newCustomers && !filter?.customerType?.repeatCustomers">
                        {{ filterTitle?.customerType?.newCustomers }}
                      </span>

                      <span *ngIf="!filter?.customerType?.newCustomers && filter?.customerType?.repeatCustomers">
                        {{ filterTitle?.customerType?.repeatCustomers }}
                      </span>

                      <span *ngIf="!filter?.customerType?.newCustomers && !filter?.customerType?.repeatCustomers">
                        {{ filterTitle?.customerType?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.customerType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.customerType"
                        (click)="clearFilter('customerType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest"
                      (click)="onChange('customerType', 'newCustomers')">
                      <app-checkbox [isChecked]="filter.customerType.newCustomers"> </app-checkbox>
                      {{ filterTitle.customerType.newCustomers }}
                    </div>

                    <div class="filter-option border-bottom-lightest"
                      (click)="onChange('customerType', 'repeatCustomers')">
                      <app-checkbox [isChecked]="filter.customerType.repeatCustomers"> </app-checkbox>
                      {{ filterTitle.customerType.repeatCustomers }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Customer Type -->
          </div>

          <div class="single-filter" *ngIf="options.customerFleet">
            <h4>Type</h4>
            <!-- Start Type -->
            <div class="filter-pill type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.customerFleet }">
                    <div class="icon">
                      <i class="fal fa-user"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span
                        *ngIf="(filter?.customerFleet?.fleet && filter?.customerFleet?.regular) || (!filter?.customerFleet?.fleet && !filter?.customerFleet?.regular)">
                        {{ filterTitle?.customerFleet?.all }}
                      </span>

                      <span *ngIf="filter?.customerFleet?.fleet && !filter?.customerFleet?.regular">
                        {{ filterTitle?.customerFleet?.fleet }}
                      </span>

                      <span *ngIf="!filter?.customerFleet?.fleet && filter?.customerFleet?.regular">
                        {{ filterTitle?.customerFleet?.regular }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.customerFleet"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.customerFleet"
                        (click)="clearFilter('customerFleet')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('customerFleet', 'regular')">
                      <app-checkbox [isChecked]="filter.customerFleet.regular"> </app-checkbox>
                      {{ filterTitle.customerFleet?.regular }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('customerFleet', 'fleet')">
                      <app-checkbox [isChecked]="filter.customerFleet.fleet"> </app-checkbox>
                      {{ filterTitle.customerFleet?.fleet }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Type -->
          </div>

          <div class="single-filter" *ngIf="options.tags">
            <h4>Tags</h4>
            <!-- Start Tags -->
            <div class="filter-pill tags" [ngClass]="{ 'width-100px': path === '/reports/all-payments' }">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tags }">
                    <div class="icon">
                      <i class="fal fa-tags"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <span *ngIf="filter?.tags?.selected?.length === 0">{{ filterTitle?.tags?.all }}</span>
                      <span *ngIf="filter?.tags?.selected?.length === 1">{{ (filter?.tags?.selected)[0]?.name }}</span>
                      <span *ngIf="filter?.tags?.selected?.length > 1">{{ filterTitle?.tags?.multiple }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.tags"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.tags" (click)="clearFilter('tags')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-180 text-overflow-ellipsis">
                    <app-multiple-filter scrollHeight="265px" [data]="tags" (appChangeFilter)="changeTagFilter($event)">
                    </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Tags -->
          </div>

          <div class="single-filter" *ngIf="options.genericFilter">
            <!-- Start item source -->
            <h4>{{genericFilterOptions?.selectAllText}}</h4>
            <div class="filter-pill company-name">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.genericFilter }">
                    <div class="icon">
                      <i class="fal" [ngClass]="genericFilterOptions?.iconClass"></i>
                    </div>

                    <div class="w-100 text-overflow-ellipsis" [ngStyle]="genericFilterOptions?.styleCss">
                      <span *ngIf="filter?.genericFilter?.selected?.length === 0">{{
                        genericFilterOptions?.selectAllText}}</span>
                      <span *ngIf="filter?.genericFilter?.selected?.length === 1">{{
                        (filter?.genericFilter?.selected)[0][genericFilterOptions?.nameField] }}</span>
                      <span *ngIf="filter?.genericFilter?.selected?.length > 1">{{
                        genericFilterOptions?.multipleSelectText ?
                        genericFilterOptions?.multipleSelectText : 'Multiple Select' }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.genericFilter"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.genericFilter"
                        (click)="clearFilter('genericFilter')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-180 text-overflow-ellipsis"
                    [ngStyle]="genericFilterOptions?.filterOverlayStyle">
                    <app-multiple-filter scrollHeight="265px" [nameField]="genericFilterOptions?.nameField"
                      [countField]="genericFilterOptions?.countField" [data]="genericFilterData"
                      (appChangeFilter)="onSelectGenericFilter($event)"> </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End item source -->
          </div>

          <div class="single-filter" *ngIf="options.companyName">
            <h4>Company Name</h4>
            <!-- Start Company name -->
            <div class="filter-pill company-name">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.companyName }">
                    <div class="icon">
                      <i class="fal fa-tags"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <span *ngIf="filter?.companyName?.selected?.length === 0">{{ filterTitle?.companyName?.all
                        }}</span>
                      <span *ngIf="filter?.companyName?.selected?.length === 1">{{
                        (filter?.companyName?.selected)[0]?.name }}</span>
                      <span *ngIf="filter?.companyName?.selected?.length > 1">{{ filterTitle?.companyName?.multiple
                        }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.companyName"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.companyName"
                        (click)="clearFilter('companyName')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-180 text-overflow-ellipsis">
                    <app-multiple-filter scrollHeight="265px" [data]="companyNames"
                      (appChangeFilter)="onSelectCompanyName($event)"> </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End company name -->
          </div>

          <div class="single-filter" *ngIf="options.aging">
            <h4>Agging</h4>
            <!-- Start Agging -->
            <div class="filter-pill agging">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="0%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.aging }">
                    <div class="icon">
                      <i class="fal fa-bell-exclamation"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      {{ filterTitle?.aging }}
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.aging"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.aging" (click)="clearFilter('aging')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-120">
                    <app-single-filter scrollHeight="260px" valueField="id" [selectedValue]="this.filter.aging"
                      [data]="agingOptions" (appChangeFilter)="onSelectAging($event)"> </app-single-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Agging -->
          </div>

          <div class="single-filter" *ngIf="options.payment">
            <h4>Payment</h4>
            <!-- Start Payment -->
            <div class="filter-pill payment">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.payment }">
                    <div class="icon">
                      <i class="fal fa-credit-card"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span>{{ showPaymentPill() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.payment"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.payment" (click)="clearFilter('payment')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option" (click)="onChange('payment', 'unpaid')">
                      <app-checkbox [isChecked]="filter.payment.unpaid"> </app-checkbox>
                      {{ filterTitle.payment.unpaid }}
                    </div>

                    <div class="filter-option" (click)="onChange('payment', 'partiallyPaid')">
                      <app-checkbox [isChecked]="filter.payment.partiallyPaid"> </app-checkbox>
                      {{ filterTitle.payment.partiallyPaid }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Payment -->
          </div>

          <div class="single-filter" *ngIf="options.qboStatus">
            <h4>QBO Status</h4>
            <!-- Start QBO Status -->
            <div class="filter-pill qbo-status">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.qboStatus }">
                    <div class="icon">
                      <i class="fal fa-coins"></i>
                    </div>

                    <div class="filter-text w-120px text-overflow-ellipsis mr-1">
                      <span>{{ showqboStatusTitle() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.qboStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.qboStatus" (click)="clearFilter('qboStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option" (click)="onChange('qboStatus', 'synced')">
                      <app-checkbox [isChecked]="filter.qboStatus.synced"> </app-checkbox>
                      {{ filterTitle.qboStatus.synced }}
                    </div>

                    <div class="filter-option" (click)="onChange('qboStatus', 'notSynced')">
                      <app-checkbox [isChecked]="filter.qboStatus.notSynced"> </app-checkbox>
                      {{ filterTitle.qboStatus.notSynced }}
                    </div>

                    <div class="filter-option" (click)="onChange('qboStatus', 'notPosted')">
                      <app-checkbox [isChecked]="filter.qboStatus.notPosted"> </app-checkbox>
                      {{ filterTitle.qboStatus.notPosted }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End QBO Status -->
          </div>

          <div class="single-filter" *ngIf="options.paymentSubType">
            <h4>Payment Method</h4>
            <!-- Start Payment Type -->
            <div class="filter-pill payment-sub-type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentSubType }">
                    <div class="icon">
                      <i class="fal fa-stream"></i>
                    </div>

                    <div class="filter-text w-120px text-overflow-ellipsis mr-1">
                      <span>Payment method</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentSubType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.paymentSubType"
                        (click)="clearFilter('paymentSubType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay" let-close="close">
                  <div class="filter-overlay w-160">
                    <div *ngIf="!filterApplied.paymentType" class="filter-option">Select Payment Type</div>
                    <div *ngFor="let filterOption of filter.paymentSubTypeFilterOption"
                      (click)="onSubTypeSelect(filterOption._id)">
                      <div *ngIf="filter.paymentSubTypeFilterOption.length > 0" class="filter-option">
                        <app-checkbox [isChecked]="filterOption.selected"> </app-checkbox>
                        {{ filterOption.name }}
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Payment Type -->
          </div>

          <div class="single-filter" *ngIf="options.paymentType">
            <h4>Payment Type</h4>
            <!-- Start Payment Type -->
            <div class="filter-pill payment-type-1">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentType }">
                    <div class="icon">
                      <i class="fal fa-file-invoice"></i>
                    </div>

                    <div class="filter-text w-120px text-overflow-ellipsis mr-1">
                      <span>{{ showPaymentTypeTitle() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.paymentType"
                        (click)="clearFilter('paymentType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay" let-close="close">
                  <div class="filter-overlay w-160">
                    <div class="filter-option" (click)="onChange('paymentType', 'cash')">
                      <app-checkbox [isChecked]="filter.paymentType.cash"> </app-checkbox>
                      {{ filterTitle.paymentType.cash }}
                    </div>

                    <div *ngIf="!isOnlinePayAvailable" class="filter-option" (click)="onChange('paymentType', 'card')">
                      <app-checkbox [isChecked]="filter.paymentType.card"> </app-checkbox>
                      {{ filterTitle.paymentType.card }}
                    </div>
                    <div *ngIf="isOnlinePayAvailable" class="filter-option"
                      (click)="onChange('paymentType', 'cardManual')">
                      <app-checkbox [isChecked]="filter.paymentType.cardManual"> </app-checkbox>
                      {{ filterTitle.paymentType.cardManual }}
                    </div>
                    <div *ngIf="isOnlinePayAvailable" class="filter-option"
                      (click)="onChange('paymentType', 'cardOnline')">
                      <app-checkbox [isChecked]="filter.paymentType.cardOnline"> </app-checkbox>
                      {{ filterTitle.paymentType.cardOnline }}
                    </div>
                    <div *ngIf="isOnlinePayAvailable" class="filter-option"
                      (click)="onChange('paymentType', 'cardSwipe')">
                      <app-checkbox [isChecked]="filter.paymentType.cardSwipe"> </app-checkbox>
                      {{ filterTitle.paymentType.cardSwipe }}
                    </div>

                    <div class="filter-option" (click)="onChange('paymentType', 'cheque')">
                      <app-checkbox [isChecked]="filter.paymentType.cheque"> </app-checkbox>
                      {{ filterTitle.paymentType.cheque }}
                    </div>

                    <div  class="filter-option"
                      (click)="onChange('paymentType', 'creditPayment')">
                      <app-checkbox [isChecked]="filter.paymentType.creditPayment"> </app-checkbox>
                      {{ filterTitle.paymentType.creditPayment }}
                    </div>

                    <div *ngIf="isRevenueRecognitionSettleEnabled" class="filter-option"
                      (click)="onChange('paymentType', 'thirdParty')">
                      <app-checkbox [isChecked]="filter.paymentType.thirdParty"> </app-checkbox>
                      {{ filterTitle.paymentType.thirdParty }}
                    </div>

                    <div *ngIf="isRevenueRecognitionSettleEnabled && isWriteOffEnable" class="filter-option"
                      (click)="onChange('paymentType', 'writeOff')">
                      <app-checkbox [isChecked]="filter.paymentType?.writeOff"> </app-checkbox>
                      {{ filterTitle.paymentType?.writeOff }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Payment Type -->
          </div>

          <div class="single-filter" *ngIf="options.paymentGroup">
            <h4>Payment Group</h4>
            <!-- Start Payment Group -->
            <div class="filter-pill payment-group">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-8%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentGroup }">
                    <div class="icon">
                      <i class="fal fa-archive"></i>
                    </div>

                    <div class="filter-text w-120px text-overflow-ellipsis">
                      <span *ngIf="filter?.paymentGroup?.refund
                      && filter?.paymentGroup?.payment
                      && filter?.paymentGroup?.void">
                        {{ filterTitle?.paymentGroup?.all }}
                      </span>

                      <span *ngIf="filter?.paymentGroup?.refund
                      && !filter?.paymentGroup?.void
                      && !filter?.paymentGroup?.payment">
                        {{ filterTitle?.paymentGroup?.refund }}
                      </span>

                      <span
                        *ngIf="!filter?.paymentGroup?.refund && !filter?.paymentGroup?.void && filter?.paymentGroup?.payment">
                        {{ filterTitle?.paymentGroup?.payment }}
                      </span>

                      <span *ngIf="filter?.paymentGroup?.void &&
                      !filter?.paymentGroup?.payment &&
                      !filter?.paymentGroup?.refund">
                        {{ filterTitle?.paymentGroup?.void }}
                      </span>

                      <span *ngIf="filter?.paymentGroup?.refund === false
                      && filter?.paymentGroup?.payment === false
                      && filter?.paymentGroup?.void === false">
                        {{ filterTitle?.paymentGroup?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentGroup"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.paymentGroup"
                        (click)="clearFilter('paymentGroup')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-140">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('paymentGroup', 'refund')">
                      <app-checkbox [isChecked]="filter.paymentGroup.refund"> </app-checkbox>
                      {{ filterTitle.paymentGroup.refund }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('paymentGroup', 'void')">
                      <app-checkbox [isChecked]="filter.paymentGroup.void"> </app-checkbox>
                      {{ filterTitle.paymentGroup.void }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('paymentGroup', 'payment')">
                      <app-checkbox [isChecked]="filter.paymentGroup.payment"> </app-checkbox>
                      {{ filterTitle.paymentGroup.payment }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Payment Group -->
          </div>

          <div class="single-filter" *ngIf="options.location">
            <h4>Location</h4>
            <!-- Start Location -->
            <div class="filter-pill location">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.location }">
                    <div class="icon">
                      <i class="fal fa-map-marker-alt"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <span *ngIf="filter?.location?.selected?.length === 0">{{ filterTitle?.location?.all }}</span>
                      <span *ngIf="filter?.location?.selected?.length === 1">{{ (filter?.location?.selected)[0]?.name
                        }}</span>
                      <span *ngIf="filter?.location?.selected?.length > 1">{{ filterTitle?.location?.multiple }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.location"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.location" (click)="clearFilter('location')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-180 text-overflow-ellipsis">
                    <app-multiple-filter scrollHeight="265px" [data]="locations"
                      (appChangeFilter)="changeLocationsFilter($event)"> </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Items -->
          </div>

          <div class="single-filter" *ngIf="options.qtyType">
            <h4>Quantity</h4>
            <!-- Start Quantity Type -->
            <div class="filter-pill quantity">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.qtyType }">
                    <div class="icon">
                      <i class="fal fa-boxes"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span> {{ getQuantityTypeTitle() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.qtyType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.qtyType" (click)="clearFilter('qtyType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div *ngFor="let key of getFilterKeys('qtyType')" class="filter-option border-bottom-lightest"
                      (click)="onChange('qtyType', key)">
                      <app-checkbox [isChecked]="filter.qtyType[key]"> </app-checkbox>
                      {{ filterTitle.qtyType[key] }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Quantity Type -->
          </div>
          <div class="single-filter" *ngIf="options.sendStatus">
            <h4>Send Status</h4>
            <!-- Start send status -->
            <div class="filter-pill quantity">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.sendStatus }">
                    <div class="icon">
                      <i class="fal fa-paper-plane"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span> {{ getSendStatusTitle() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.sendStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.sendStatus" (click)="clearFilter('sendStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div *ngFor="let key of getSendFilterKeys('sendStatus')"
                      class="filter-option border-bottom-lightest" (click)="onChange('sendStatus', key)">
                      <app-checkbox [isChecked]="filter.sendStatus[key]"> </app-checkbox>
                      {{ filterTitle.sendStatus[key] }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End send status -->
          </div>

          <div class="single-filter pt-1" *ngIf="options.paidStatus">
            <h4>Paid Status</h4>
            <!-- Start paid status -->
            <div class="filter-pill quantity">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paidStatus }">
                    <div class="icon">
                      <i class="fal fa-ballot-check"></i>
                    </div>

                    <div class="filter-text w-80px text-overflow-ellipsis">
                      <span> {{ getPaidStatusTitle() }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.paidStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.paidStatus" (click)="clearFilter('paidStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div *ngFor="let key of getPaidFilterKeys('paidStatus')"
                      class="filter-option border-bottom-lightest" (click)="onChange('paidStatus', key)">
                      <app-checkbox [isChecked]="filter.paidStatus[key]"> </app-checkbox>
                      {{ filterTitle.paidStatus[key] }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End send status -->
          </div>

          <div class="single-filter" *ngIf="options.items">
            <h4>Start Items</h4>
            <!-- Start Items -->
            <div class="filter-pill item-filter">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.items }">
                    <div class="icon">
                      <i class="fal fa-warehouse-alt"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <span *ngIf="filter?.items?.selected?.length === 0">{{ filterTitle?.items?.all }}</span>
                      <span *ngIf="filter?.items?.selected?.length === 1">{{ (filter?.items?.selected)[0]?.name
                        }}</span>
                      <span *ngIf="filter?.items?.selected?.length > 1">{{ filterTitle?.items?.multiple }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.items"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.items" (click)="clearFilter('items')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-180 text-overflow-ellipsis">
                    <app-multiple-filter scrollHeight="265px" [data]="items"
                      (appChangeFilter)="changeItemsFilter($event)"> </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Items -->
          </div>

          <div class="single-filter" *ngIf="options.itemType">
            <h4>Item Type</h4>
            <!-- Start item Type -->
            <div class="filter-pill customer-type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [closeAfterAction]="closeAfterAction"
                right="-3%">

                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.itemType }">
                    <div class="icon">
                      <i class="fal fa-warehouse-alt"></i>
                    </div>

                    <div class="filter-text w-110px text-overflow-ellipsis">
                      <span
                        *ngIf="filter?.itemType?.tire && filter?.itemType?.part && filter?.itemType?.labor && filter?.itemType?.sublet && filter?.itemType?.other && filter?.itemType?.tireStorage && path !== '/reports/enhance-item-sold'">
                        {{ filterTitle?.itemType?.all }}
                      </span>

                      <span *ngIf="filter?.itemType?.tire && path !== '/reports/enhance-item-sold'">{{
                        filterTitle?.itemType?.tire }}</span>
                      <span *ngIf="filter?.itemType?.part && path !== '/reports/enhance-item-sold'">{{
                        filterTitle?.itemType?.part }}</span>

                      <div *ngIf="isItemSoldReportEnhancement && path === '/reports/enhance-item-sold'" class="d-flex">
                        <span *ngIf="filter?.itemType?.tire">{{ filterTitle?.itemType?.tire }}</span>
                        <span *ngIf="filter?.itemType?.part" class="pl-1">{{ filterTitle?.itemType?.part }}</span>
                        <span *ngIf="filter?.itemType?.labor" class="pl-1">{{ filterTitle?.itemType?.labor }}</span>
                        <span *ngIf="filter?.itemType?.sublet" class="pl-1">{{ filterTitle?.itemType?.sublet }}</span>
                        <span *ngIf="filter?.itemType?.other" class="pl-1">{{ filterTitle?.itemType?.other }}</span>
                        <span *ngIf="filter?.itemType?.tireStorage" class="pl-1">{{ filterTitle?.itemType?.tireStorage
                          }}</span>
                      </div>

                      <span
                        *ngIf="!filter?.itemType?.tire && !filter?.itemType?.part && path !== '/reports/enhance-item-sold'">
                        {{ filterTitle?.itemType?.all }}
                      </span>

                      <div *ngIf="path === '/reports/enhance-item-sold'">
                        <span
                          *ngIf="!filter?.itemType?.tire && !filter?.itemType?.part && !filter?.itemType?.labor && !filter?.itemType?.sublet && !filter?.itemType?.other && !filter?.itemType?.tireStorage">
                          {{ filterTitle?.itemType?.all }}
                        </span>
                      </div>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.itemType" (click)="clearFilter('itemType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'tire')">
                      <app-checkbox [isChecked]="filter.itemType.tire"></app-checkbox>
                      {{ filterTitle.itemType.tire }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'part')">
                      <app-checkbox [isChecked]="filter.itemType.part"></app-checkbox>
                      {{ filterTitle.itemType.part }}
                    </div>

                    <div *ngIf="path === '/reports/enhance-item-sold'">
                      <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'labor')">
                        <app-checkbox [isChecked]="filter.itemType.labor"></app-checkbox>
                        {{ filterTitle.itemType.labor }}
                      </div>

                      <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'sublet')">
                        <app-checkbox [isChecked]="filter.itemType.sublet"></app-checkbox>
                        {{ filterTitle.itemType.sublet }}
                      </div>

                      <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'other')">
                        <app-checkbox [isChecked]="filter.itemType.other"></app-checkbox>
                        {{ filterTitle.itemType.other }}
                      </div>

                      <div class="filter-option border-bottom-lightest" (click)="onChange('itemType', 'tireStorage')">
                        <app-checkbox [isChecked]="filter.itemType.tireStorage"></app-checkbox>
                        {{ filterTitle.itemType.tireStorage }}
                      </div>
                    </div>
                  </div>
                </ng-template>

              </app-content-overlay>

            </div>
            <!-- End item Type -->
          </div>

          <div class="single-filter" *ngIf="options.itemCategory">
            <h4>Item Category</h4>
            <!-- Start item Category -->
            <div class="filter-pill company-name">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.itemCategory }">
                    <div class="icon">
                      <i class="fal fa-warehouse-alt"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <span *ngIf="filter?.itemCategory?.selected?.length === 0">{{ filterTitle?.itemCategory?.all
                        }}</span>
                      <span *ngIf="filter?.itemCategory?.selected?.length === 1">{{
                        (filter?.itemCategory?.selected)[0]?.name }}</span>
                      <span *ngIf="filter?.itemCategory?.selected?.length > 1">{{ filterTitle?.itemCategory?.multiple
                        }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemCategory"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.itemCategory"
                        (click)="clearFilter('itemCategory')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-180 text-overflow-ellipsis">
                    <app-multiple-filter scrollHeight="265px" [data]="itemCategorys"
                      (appChangeFilter)="onSelectItemCategory($event)"> </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End item Category -->
          </div>

          <div class="single-filter pt-1" *ngIf="options.supplier">
            <h4>Supplier name</h4>
            <!-- Start Supplier name -->
            <div class="filter-pill company-name">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-13%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.supplier }">
                    <div class="icon">
                      <i class="fal fa-warehouse-alt"></i>
                    </div>

                    <div class="filter-text w-90px text-overflow-ellipsis">
                      <span *ngIf="filter?.supplier?.selected?.length === 0 || !filter?.supplier?.selected?.length">{{
                        filterTitle?.supplier?.all }}</span>
                      <span *ngIf="filter?.supplier?.selected?.length === 1">{{ (filter?.supplier?.selected)[0]?.name
                        }}</span>
                      <span *ngIf="filter?.supplier?.selected?.length > 1">{{ filterTitle?.supplier?.multiple }}</span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.supplier"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.supplier" (click)="clearFilter('supplier')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-180 text-overflow-ellipsis">
                    <app-multiple-filter scrollHeight="265px" [data]="suppliers"
                      (appChangeFilter)="onSelectSupplierName($event)"> </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Supplier name -->
          </div>

          <div class="single-filter" *ngIf="options.supplierType">
            <h4>Supplier Type</h4>
            <div class="filter-pill customer-type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.supplierType }">
                    <div class="icon">
                      <i class="fal fa-warehouse-alt"></i>
                    </div>

                    <div class="filter-text w-110px text-overflow-ellipsis">
                      <span *ngIf="filter?.supplierType?.internal && filter?.supplierType?.online">
                        {{ filterTitle?.supplierType?.all }}
                      </span>

                      <span *ngIf="filter?.supplierType?.internal && !filter?.supplierType?.online">
                        {{ filterTitle?.supplierType?.internal }}
                      </span>

                      <span *ngIf="!filter?.supplierType?.internal && filter?.supplierType?.online">
                        {{ filterTitle?.supplierType?.online }}
                      </span>

                      <span *ngIf="!filter?.supplierType?.internal && !filter?.supplierType?.online">
                        {{ filterTitle?.supplierType?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.supplierType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.supplierType"
                        (click)="clearFilter('supplierType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('supplierType', 'internal')">
                      <app-checkbox [isChecked]="filter.supplierType.internal"> </app-checkbox>
                      {{ filterTitle.supplierType.internal }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('supplierType', 'online')">
                      <app-checkbox [isChecked]="filter.supplierType.online"> </app-checkbox>
                      {{ filterTitle.supplierType.online }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Supplier Type -->
          </div>

          <div class="single-filter" *ngIf="options.feeType">
            <h4>Fee type</h4>
            <!-- Start Fee type -->
            <div class="filter-pill customer-type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.feeType }">
                    <div class="icon">
                      <i class="fal fa-usd-circle"></i>
                    </div>

                    <div class="filter-text w-110px text-overflow-ellipsis">
                      <span
                        *ngIf="(filter?.feeType?.serviceLevel && filter?.feeType?.roLevel) || (filter?.feeType?.serviceLevel && filter?.feeType?.passThroughTax) || (filter?.feeType?.passThroughTax && filter?.feeType?.roLevel)">
                        {{ filterTitle?.feeType?.all }}
                      </span>

                      <span
                        *ngIf="filter?.feeType?.serviceLevel && !filter?.feeType?.roLevel && !filter?.feeType?.passThroughTax">
                        {{ filterTitle?.feeType?.serviceLevel }}
                      </span>

                      <span
                        *ngIf="!filter?.feeType?.serviceLevel && !filter?.feeType?.passThroughTax && filter?.feeType?.roLevel">
                        {{ filterTitle?.feeType?.roLevel }}
                      </span>

                      <span
                        *ngIf="!filter?.feeType?.serviceLevel && filter?.feeType?.passThroughTax && !filter?.feeType?.roLevel">
                        {{ filterTitle?.feeType?.passThroughTax }}
                      </span>

                      <span
                        *ngIf="!filter?.feeType?.serviceLevel && !filter?.feeType?.roLevel && !filter?.feeType?.passThroughTax">
                        {{ filterTitle?.feeType?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.feeType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.feeType" (click)="clearFilter('feeType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('feeType', 'serviceLevel')">
                      <app-checkbox [isChecked]="filter.feeType.serviceLevel"> </app-checkbox>
                      {{ filterTitle.feeType.serviceLevel }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('feeType', 'roLevel')">
                      <app-checkbox [isChecked]="filter.feeType.roLevel"> </app-checkbox>
                      {{ filterTitle.feeType.roLevel }}
                    </div>

                    <div *ngIf="isPassThroughTaxEnable" class="filter-option border-bottom-lightest"
                      (click)="onChange('feeType', 'passThroughTax')">
                      <app-checkbox [isChecked]="filter.feeType.passThroughTax"> </app-checkbox>
                      {{ filterTitle.feeType.passThroughTax }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Fee type -->
          </div>

          <div class="single-filter" *ngIf="options.orderDiscountType">
            <h4>Discount Value</h4>
            <!-- Start Discount Value type -->
            <div class="filter-pill customer-type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderDiscountType }">
                    <div class="icon">
                      <i class="fal fa-usd-circle"></i>
                    </div>

                    <div class="filter-text w-110px text-overflow-ellipsis">
                      <span *ngIf="filter?.orderDiscountType?.percentage && filter?.orderDiscountType?.dollarValue">
                        {{ filterTitle?.orderDiscountType?.all }}
                      </span>

                      <span *ngIf="filter?.orderDiscountType?.percentage && !filter?.orderDiscountType?.dollarValue">
                        {{ filterTitle?.orderDiscountType?.percentage }}
                      </span>

                      <span *ngIf="!filter?.orderDiscountType?.percentage && filter?.orderDiscountType?.dollarValue">
                        {{ filterTitle?.orderDiscountType?.dollarValue }}
                      </span>

                      <span *ngIf="!filter?.orderDiscountType?.percentage && !filter?.orderDiscountType?.dollarValue">
                        {{ filterTitle?.orderDiscountType?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderDiscountType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.orderDiscountType"
                        (click)="clearFilter('orderDiscountType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest"
                      (click)="onChange('orderDiscountType', 'percentage')">
                      <app-checkbox [isChecked]="filter?.orderDiscountType?.percentage"> </app-checkbox>
                      {{ filterTitle?.orderDiscountType?.percentage }}
                    </div>

                    <div class="filter-option border-bottom-lightest"
                      (click)="onChange('orderDiscountType', 'dollarValue')">
                      <app-checkbox [isChecked]="filter?.orderDiscountType?.dollarValue"> </app-checkbox>
                      {{ filterTitle?.orderDiscountType?.dollarValue }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Discount Value type -->
          </div>

          <div class="single-filter" *ngIf="options.orderOn">
            <h4>Discount level type</h4>
            <!-- Start Discount level type -->
            <div class="filter-pill customer-type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.orderOn }">
                    <div class="icon">
                      <i class="fal fa-usd-circle"></i>
                    </div>

                    <div class="filter-text w-110px text-overflow-ellipsis">
                      <span *ngIf="filter?.orderOn?.serviceLevel && filter?.orderOn?.orderLevel">
                        {{ filterTitle?.orderOn?.all }}
                      </span>

                      <span *ngIf="filter?.orderOn?.serviceLevel && !filter?.orderOn?.orderLevel">
                        {{ filterTitle?.orderOn?.serviceLevel }}
                      </span>

                      <span *ngIf="!filter?.orderOn?.serviceLevel && filter?.orderOn?.orderLevel">
                        {{ filterTitle?.orderOn?.orderLevel }}
                      </span>

                      <span *ngIf="!filter?.orderOn?.serviceLevel && !filter?.orderOn?.orderLevel">
                        {{ filterTitle?.orderOn?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.orderOn"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.orderOn" (click)="clearFilter('orderOn')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('orderOn', 'serviceLevel')">
                      <app-checkbox [isChecked]="filter.orderOn.serviceLevel"> </app-checkbox>
                      {{ filterTitle.orderOn.serviceLevel }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('orderOn', 'orderLevel')">
                      <app-checkbox [isChecked]="filter.orderOn.orderLevel"> </app-checkbox>
                      {{ filterTitle.orderOn.orderLevel }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Discount level type -->
          </div>

          <div class="single-filter" *ngIf="options.addFilter">
            <h4>Customer Type</h4>
            <!-- Add Filter -->

            <!-- Start Customer Type Status -->
            <div class="filter-pill payment-status">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-18%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.customerType }">
                    <div class="icon">
                      <i class="fal fa-user"></i>
                    </div>

                    <div class="filter-text w-70px text-overflow-ellipsis">
                      <span
                        *ngIf="(filter?.customerType?.newCustomers && filter?.customerType?.repeatCustomers) || (!filter?.customerType?.newCustomers && !filter?.customerType?.repeatCustomers)">
                        {{ filterTitle?.customerType?.all }}
                      </span>
                      <span *ngIf="filter?.customerType?.newCustomers && !filter?.customerType?.repeatCustomers">
                        {{ filterTitle?.customerType?.newCustomers }}
                      </span>
                      <span *ngIf="!filter?.customerType?.newCustomers && filter?.customerType?.repeatCustomers">
                        {{ filterTitle?.customerType?.repeatCustomers }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.customerType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.customerType"
                        (click)="clearFilter('customerType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option" (click)="onChange('customerType', 'newCustomers')">
                      <app-checkbox [isChecked]="filter.customerType.newCustomers"> </app-checkbox>
                      {{ filterTitle.customerType.newCustomers }}
                    </div>
                    <div class="filter-option" (click)="onChange('customerType', 'repeatCustomers')">
                      <app-checkbox [isChecked]="filter.customerType.repeatCustomers"> </app-checkbox>
                      {{ filterTitle.customerType.repeatCustomers }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Customer Type Status -->
          </div>

          <div class="single-filter" *ngIf="options.addFilter">
            <h4>Payment Status</h4>

            <!-- Start Payment Status -->
            <div class="filter-pill payment-status">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-18%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentStatus }">
                    <div class="icon">
                      <i class="fal fa-user-hard-hat"></i>
                    </div>

                    <div class="filter-text w-70px text-overflow-ellipsis">
                      <span *ngIf="
                          (filter?.payment?.unpaid && filter?.payment?.partiallyPaid && filter?.payment?.paid) ||
                          (!filter?.payment?.unpaid && !filter?.payment?.partiallyPaid && !filter?.payment?.paid)
                        ">
                        {{ filterTitle?.payment?.all }}
                      </span>

                      <span
                        *ngIf="filter?.payment?.unpaid && !filter?.payment?.partiallyPaid && !filter?.payment?.paid">
                        {{ filterTitle?.payment?.unpaid }}
                      </span>

                      <span
                        *ngIf="!filter?.payment?.unpaid && filter?.payment?.partiallyPaid && !filter?.payment?.paid">
                        {{ filterTitle?.payment?.partiallyPaid }}
                      </span>

                      <span
                        *ngIf="!filter?.payment?.unpaid && !filter?.payment?.partiallyPaid && filter?.payment?.paid">
                        {{ filterTitle?.payment?.paid }}
                      </span>

                      <span *ngIf="filter?.payment?.unpaid && filter?.payment?.partiallyPaid && !filter?.payment?.paid">
                        {{ filterTitle?.payment?.partiallyPaid }} & {{ filterTitle?.payment?.unpaid }}
                      </span>

                      <span *ngIf="!filter?.payment?.unpaid && filter?.payment?.partiallyPaid && filter?.payment?.paid">
                        {{ filterTitle?.payment?.paid }} & {{ filterTitle?.payment?.partiallyPaid }}
                      </span>

                      <span *ngIf="filter?.payment?.unpaid && !filter?.payment?.partiallyPaid && filter?.payment?.paid">
                        {{ filterTitle?.payment?.paid }} & {{ filterTitle?.payment?.unpaid }} </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentStatus"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.paymentStatus"
                        (click)="clearFilter('paymentStatus')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option" (click)="onChange('payment', 'unpaid')">
                      <app-checkbox [isChecked]="filter.payment.unpaid"> </app-checkbox>
                      {{ filterTitle.payment.unpaid }}
                    </div>

                    <div class="filter-option" (click)="onChange('payment', 'partiallyPaid')">
                      <app-checkbox [isChecked]="filter.payment.partiallyPaid"> </app-checkbox>
                      {{ filterTitle.payment.partiallyPaid }}
                    </div>

                    <div class="filter-option" (click)="onChange('payment', 'paid')">
                      <app-checkbox [isChecked]="filter.payment.paid"> </app-checkbox>
                      {{ filterTitle.payment.paid }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End Payment Status -->
          </div>

          <div class="single-filter" *ngIf="options.itemTypeInventoryNonInventory">
            <div class="filter-pill technicians-filter">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="0%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper"
                    [ngClass]="{ 'active': filterApplied.itemTypeInventoryNonInventory }">
                    <!-- Icon -->
                    <div class="icon"><i class="fal fa-warehouse-alt"></i></div>

                    <!-- Title -->
                    <div class="filter-text w-100px text-overflow-ellipsis">
                      <span *ngIf="filter?.itemTypeInventoryNonInventory?.selected?.length === 0">Item type</span>
                      <span
                        *ngIf="filter?.itemTypeInventoryNonInventory?.selected?.length === 1">{{filter?.itemTypeInventoryNonInventory?.selected[0]?.label}}</span>
                      <span *ngIf="filter?.itemTypeInventoryNonInventory?.selected?.length > 1">Multiple</span>
                    </div>

                    <!-- Clear -->
                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemTypeInventoryNonInventory"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.itemTypeInventoryNonInventory"
                        (click)="clearFilter('itemTypeInventoryNonInventory')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <app-multiple-filter scrollHeight="260px" nameField="label" [data]="itemTypeInventoryNonInventory"
                      (appChangeFilter)="changeItemTypeInventoryNonInventory($event)">
                    </app-multiple-filter>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
          </div>

          <div class="single-filter" *ngIf="options.warrantyType">
            <h4>Warranty Type</h4>
            <!-- Start item Type -->
            <div class="filter-pill customer-type">
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
                [closeAfterAction]="closeAfterAction" right="-3%">
                <ng-template appTemplate="item">
                  <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.warrantyType }">
                    <div class="icon">
                      <i class="fal fa-warehouse-alt"></i>
                    </div>

                    <div class="filter-text w-110px text-overflow-ellipsis">
                      <span *ngIf="filter?.warrantyType?.first && filter?.warrantyType?.replacement">
                        {{ filterTitle?.warrantyType?.all }}
                      </span>

                      <span *ngIf="filter?.warrantyType?.first && !filter?.warrantyType?.replacement">
                        {{ filterTitle?.warrantyType?.first }}
                      </span>

                      <span *ngIf="!filter?.warrantyType?.first && filter?.warrantyType?.replacement">
                        {{ filterTitle?.warrantyType?.replacement }}
                      </span>

                      <span *ngIf="!filter?.warrantyType?.first && !filter?.warrantyType?.replacement">
                        {{ filterTitle?.warrantyType?.all }}
                      </span>
                    </div>

                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!filterApplied.warrantyType"></i>
                      <i class="fal fa-times" *ngIf="filterApplied.warrantyType"
                        (click)="clearFilter('warrantyType')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-160">
                    <div class="filter-option border-bottom-lightest" (click)="onChange('warrantyType', 'first')">
                      <app-checkbox [isChecked]="filter.warrantyType.first"> </app-checkbox>
                      {{ filterTitle.warrantyType.first }}
                    </div>

                    <div class="filter-option border-bottom-lightest" (click)="onChange('warrantyType', 'replacement')">
                      <app-checkbox [isChecked]="filter.warrantyType.replacement"> </app-checkbox>
                      {{ filterTitle.warrantyType.replacement }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
            <!-- End item Type -->
          </div>

        </div>
      </div>
      <div class="drawer-footer">
        <button class="btn btn-border btn-block flex-center-center" (click)="resetFilters(true)">
          Reset
          <!-- <i class="fad fa-spinner rotate" *ngIf="isLoading"></i> -->
        </button>
      </div>
    </div>
  </div>

</div>
